/**
 * Generated by @openapi-codegen
 *
 * @version 1.0
 */
import * as reactQuery from '@tanstack/react-query';
import { type ApiContext, useApiContext, queryKeyFn } from './apiContext';
import { deepMerge } from './apiUtils';
import type * as Fetcher from './apiFetcher';
import { apiFetch } from './apiFetcher';
import type * as Schemas from './apiSchemas';

type QueryFnOptions = {
  signal?: AbortController['signal'];
};

export type DashboardProgressHistoryV1ControllerProgressHistoryQueryParams = {
  constructionSiteId: string;
  startDate: string;
  endDate: string;
};

export type DashboardProgressHistoryV1ControllerProgressHistoryError =
  Fetcher.ErrorWrapper<undefined>;

export type DashboardProgressHistoryV1ControllerProgressHistoryVariables = {
  queryParams: DashboardProgressHistoryV1ControllerProgressHistoryQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDashboardProgressHistoryV1ControllerProgressHistory = (
  variables: DashboardProgressHistoryV1ControllerProgressHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetDashboardProgressHistoryV1ResponseDto,
    DashboardProgressHistoryV1ControllerProgressHistoryError,
    undefined,
    {},
    DashboardProgressHistoryV1ControllerProgressHistoryQueryParams,
    {}
  >({
    url: '/v1/dashboard/progress-history',
    method: 'get',
    ...variables,
    signal,
  });

export function dashboardProgressHistoryV1ControllerProgressHistoryQuery(
  variables: DashboardProgressHistoryV1ControllerProgressHistoryVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetDashboardProgressHistoryV1ResponseDto>;
};

export function dashboardProgressHistoryV1ControllerProgressHistoryQuery(
  variables:
    | DashboardProgressHistoryV1ControllerProgressHistoryVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetDashboardProgressHistoryV1ResponseDto>)
    | reactQuery.SkipToken;
};

export function dashboardProgressHistoryV1ControllerProgressHistoryQuery(
  variables:
    | DashboardProgressHistoryV1ControllerProgressHistoryVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/dashboard/progress-history',
      operationId: 'dashboardProgressHistoryV1ControllerProgressHistory',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDashboardProgressHistoryV1ControllerProgressHistory(
              variables,
              signal,
            ),
  };
}

export const useSuspenseDashboardProgressHistoryV1ControllerProgressHistory = <
  TData = Schemas.GetDashboardProgressHistoryV1ResponseDto,
>(
  variables: DashboardProgressHistoryV1ControllerProgressHistoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetDashboardProgressHistoryV1ResponseDto,
      DashboardProgressHistoryV1ControllerProgressHistoryError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetDashboardProgressHistoryV1ResponseDto,
    DashboardProgressHistoryV1ControllerProgressHistoryError,
    TData
  >({
    ...dashboardProgressHistoryV1ControllerProgressHistoryQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDashboardProgressHistoryV1ControllerProgressHistory = <
  TData = Schemas.GetDashboardProgressHistoryV1ResponseDto,
>(
  variables:
    | DashboardProgressHistoryV1ControllerProgressHistoryVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetDashboardProgressHistoryV1ResponseDto,
      DashboardProgressHistoryV1ControllerProgressHistoryError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetDashboardProgressHistoryV1ResponseDto,
    DashboardProgressHistoryV1ControllerProgressHistoryError,
    TData
  >({
    ...dashboardProgressHistoryV1ControllerProgressHistoryQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DashboardDailyAdvancementV1ControllerRingPerShiftQueryParams = {
  constructionSiteId: string;
  startDate: string;
  endDate: string;
};

export type DashboardDailyAdvancementV1ControllerRingPerShiftError =
  Fetcher.ErrorWrapper<undefined>;

export type DashboardDailyAdvancementV1ControllerRingPerShiftVariables = {
  queryParams: DashboardDailyAdvancementV1ControllerRingPerShiftQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDashboardDailyAdvancementV1ControllerRingPerShift = (
  variables: DashboardDailyAdvancementV1ControllerRingPerShiftVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetRingPerShiftV1ResponseDto,
    DashboardDailyAdvancementV1ControllerRingPerShiftError,
    undefined,
    {},
    DashboardDailyAdvancementV1ControllerRingPerShiftQueryParams,
    {}
  >({
    url: '/v1/dashboard/daily-advancement',
    method: 'get',
    ...variables,
    signal,
  });

export function dashboardDailyAdvancementV1ControllerRingPerShiftQuery(
  variables: DashboardDailyAdvancementV1ControllerRingPerShiftVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetRingPerShiftV1ResponseDto>;
};

export function dashboardDailyAdvancementV1ControllerRingPerShiftQuery(
  variables:
    | DashboardDailyAdvancementV1ControllerRingPerShiftVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetRingPerShiftV1ResponseDto>)
    | reactQuery.SkipToken;
};

export function dashboardDailyAdvancementV1ControllerRingPerShiftQuery(
  variables:
    | DashboardDailyAdvancementV1ControllerRingPerShiftVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/dashboard/daily-advancement',
      operationId: 'dashboardDailyAdvancementV1ControllerRingPerShift',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDashboardDailyAdvancementV1ControllerRingPerShift(
              variables,
              signal,
            ),
  };
}

export const useSuspenseDashboardDailyAdvancementV1ControllerRingPerShift = <
  TData = Schemas.GetRingPerShiftV1ResponseDto,
>(
  variables: DashboardDailyAdvancementV1ControllerRingPerShiftVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetRingPerShiftV1ResponseDto,
      DashboardDailyAdvancementV1ControllerRingPerShiftError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetRingPerShiftV1ResponseDto,
    DashboardDailyAdvancementV1ControllerRingPerShiftError,
    TData
  >({
    ...dashboardDailyAdvancementV1ControllerRingPerShiftQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDashboardDailyAdvancementV1ControllerRingPerShift = <
  TData = Schemas.GetRingPerShiftV1ResponseDto,
>(
  variables:
    | DashboardDailyAdvancementV1ControllerRingPerShiftVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetRingPerShiftV1ResponseDto,
      DashboardDailyAdvancementV1ControllerRingPerShiftError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetRingPerShiftV1ResponseDto,
    DashboardDailyAdvancementV1ControllerRingPerShiftError,
    TData
  >({
    ...dashboardDailyAdvancementV1ControllerRingPerShiftQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DashboardDailyAdvancementV1ControllerDailyLengthAdvancementQueryParams =
  {
    constructionSiteId: string;
    date: string;
  };

export type DashboardDailyAdvancementV1ControllerDailyLengthAdvancementError =
  Fetcher.ErrorWrapper<undefined>;

export type DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables =
  {
    queryParams: DashboardDailyAdvancementV1ControllerDailyLengthAdvancementQueryParams;
  } & ApiContext['fetcherOptions'];

export const fetchDashboardDailyAdvancementV1ControllerDailyLengthAdvancement =
  (
    variables: DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables,
    signal?: AbortSignal,
  ) =>
    apiFetch<
      Schemas.GetDailyLengthAdvancementV1ResponseDto,
      DashboardDailyAdvancementV1ControllerDailyLengthAdvancementError,
      undefined,
      {},
      DashboardDailyAdvancementV1ControllerDailyLengthAdvancementQueryParams,
      {}
    >({
      url: '/v1/dashboard/daily-advancement/daily-length',
      method: 'get',
      ...variables,
      signal,
    });

export function dashboardDailyAdvancementV1ControllerDailyLengthAdvancementQuery(
  variables: DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetDailyLengthAdvancementV1ResponseDto>;
};

export function dashboardDailyAdvancementV1ControllerDailyLengthAdvancementQuery(
  variables:
    | DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetDailyLengthAdvancementV1ResponseDto>)
    | reactQuery.SkipToken;
};

export function dashboardDailyAdvancementV1ControllerDailyLengthAdvancementQuery(
  variables:
    | DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/dashboard/daily-advancement/daily-length',
      operationId:
        'dashboardDailyAdvancementV1ControllerDailyLengthAdvancement',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDashboardDailyAdvancementV1ControllerDailyLengthAdvancement(
              variables,
              signal,
            ),
  };
}

export const useSuspenseDashboardDailyAdvancementV1ControllerDailyLengthAdvancement =
  <TData = Schemas.GetDailyLengthAdvancementV1ResponseDto,>(
    variables: DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.GetDailyLengthAdvancementV1ResponseDto,
        DashboardDailyAdvancementV1ControllerDailyLengthAdvancementError,
        TData
      >,
      'queryKey' | 'queryFn' | 'initialData'
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useApiContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.GetDailyLengthAdvancementV1ResponseDto,
      DashboardDailyAdvancementV1ControllerDailyLengthAdvancementError,
      TData
    >({
      ...dashboardDailyAdvancementV1ControllerDailyLengthAdvancementQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useDashboardDailyAdvancementV1ControllerDailyLengthAdvancement = <
  TData = Schemas.GetDailyLengthAdvancementV1ResponseDto,
>(
  variables:
    | DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetDailyLengthAdvancementV1ResponseDto,
      DashboardDailyAdvancementV1ControllerDailyLengthAdvancementError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetDailyLengthAdvancementV1ResponseDto,
    DashboardDailyAdvancementV1ControllerDailyLengthAdvancementError,
    TData
  >({
    ...dashboardDailyAdvancementV1ControllerDailyLengthAdvancementQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type PerformanceMetricsControllerGetPerformanceMetricsQueryParams = {
  constructionSiteId: string;
};

export type PerformanceMetricsControllerGetPerformanceMetricsError =
  Fetcher.ErrorWrapper<undefined>;

export type PerformanceMetricsControllerGetPerformanceMetricsVariables = {
  queryParams: PerformanceMetricsControllerGetPerformanceMetricsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchPerformanceMetricsControllerGetPerformanceMetrics = (
  variables: PerformanceMetricsControllerGetPerformanceMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetPerformanceMetricsResponseDto,
    PerformanceMetricsControllerGetPerformanceMetricsError,
    undefined,
    {},
    PerformanceMetricsControllerGetPerformanceMetricsQueryParams,
    {}
  >({
    url: '/dashboard/performance-metrics',
    method: 'get',
    ...variables,
    signal,
  });

export function performanceMetricsControllerGetPerformanceMetricsQuery(
  variables: PerformanceMetricsControllerGetPerformanceMetricsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetPerformanceMetricsResponseDto>;
};

export function performanceMetricsControllerGetPerformanceMetricsQuery(
  variables:
    | PerformanceMetricsControllerGetPerformanceMetricsVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetPerformanceMetricsResponseDto>)
    | reactQuery.SkipToken;
};

export function performanceMetricsControllerGetPerformanceMetricsQuery(
  variables:
    | PerformanceMetricsControllerGetPerformanceMetricsVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/dashboard/performance-metrics',
      operationId: 'performanceMetricsControllerGetPerformanceMetrics',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchPerformanceMetricsControllerGetPerformanceMetrics(
              variables,
              signal,
            ),
  };
}

export const useSuspensePerformanceMetricsControllerGetPerformanceMetrics = <
  TData = Schemas.GetPerformanceMetricsResponseDto,
>(
  variables: PerformanceMetricsControllerGetPerformanceMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetPerformanceMetricsResponseDto,
      PerformanceMetricsControllerGetPerformanceMetricsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetPerformanceMetricsResponseDto,
    PerformanceMetricsControllerGetPerformanceMetricsError,
    TData
  >({
    ...performanceMetricsControllerGetPerformanceMetricsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const usePerformanceMetricsControllerGetPerformanceMetrics = <
  TData = Schemas.GetPerformanceMetricsResponseDto,
>(
  variables:
    | PerformanceMetricsControllerGetPerformanceMetricsVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetPerformanceMetricsResponseDto,
      PerformanceMetricsControllerGetPerformanceMetricsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetPerformanceMetricsResponseDto,
    PerformanceMetricsControllerGetPerformanceMetricsError,
    TData
  >({
    ...performanceMetricsControllerGetPerformanceMetricsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DashboardTbmInfosV1ControllerGetTbmInfosQueryParams = {
  constructionSiteId: string;
};

export type DashboardTbmInfosV1ControllerGetTbmInfosError =
  Fetcher.ErrorWrapper<undefined>;

export type DashboardTbmInfosV1ControllerGetTbmInfosVariables = {
  queryParams: DashboardTbmInfosV1ControllerGetTbmInfosQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDashboardTbmInfosV1ControllerGetTbmInfos = (
  variables: DashboardTbmInfosV1ControllerGetTbmInfosVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetDashboardTbmInfosV1ResponseDto,
    DashboardTbmInfosV1ControllerGetTbmInfosError,
    undefined,
    {},
    DashboardTbmInfosV1ControllerGetTbmInfosQueryParams,
    {}
  >({ url: '/v1/dashboard/tbm-infos', method: 'get', ...variables, signal });

export function dashboardTbmInfosV1ControllerGetTbmInfosQuery(
  variables: DashboardTbmInfosV1ControllerGetTbmInfosVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetDashboardTbmInfosV1ResponseDto>;
};

export function dashboardTbmInfosV1ControllerGetTbmInfosQuery(
  variables:
    | DashboardTbmInfosV1ControllerGetTbmInfosVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetDashboardTbmInfosV1ResponseDto>)
    | reactQuery.SkipToken;
};

export function dashboardTbmInfosV1ControllerGetTbmInfosQuery(
  variables:
    | DashboardTbmInfosV1ControllerGetTbmInfosVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/dashboard/tbm-infos',
      operationId: 'dashboardTbmInfosV1ControllerGetTbmInfos',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDashboardTbmInfosV1ControllerGetTbmInfos(variables, signal),
  };
}

export const useSuspenseDashboardTbmInfosV1ControllerGetTbmInfos = <
  TData = Schemas.GetDashboardTbmInfosV1ResponseDto,
>(
  variables: DashboardTbmInfosV1ControllerGetTbmInfosVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetDashboardTbmInfosV1ResponseDto,
      DashboardTbmInfosV1ControllerGetTbmInfosError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetDashboardTbmInfosV1ResponseDto,
    DashboardTbmInfosV1ControllerGetTbmInfosError,
    TData
  >({
    ...dashboardTbmInfosV1ControllerGetTbmInfosQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDashboardTbmInfosV1ControllerGetTbmInfos = <
  TData = Schemas.GetDashboardTbmInfosV1ResponseDto,
>(
  variables:
    | DashboardTbmInfosV1ControllerGetTbmInfosVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetDashboardTbmInfosV1ResponseDto,
      DashboardTbmInfosV1ControllerGetTbmInfosError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetDashboardTbmInfosV1ResponseDto,
    DashboardTbmInfosV1ControllerGetTbmInfosError,
    TData
  >({
    ...dashboardTbmInfosV1ControllerGetTbmInfosQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DataAnalysisControllerGraphByPeriodError =
  Fetcher.ErrorWrapper<undefined>;

export type DataAnalysisControllerGraphByPeriodVariables = {
  body: Schemas.GetGraphByPeriodDtoV5;
} & ApiContext['fetcherOptions'];

export const fetchDataAnalysisControllerGraphByPeriod = (
  variables: DataAnalysisControllerGraphByPeriodVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GraphByPeriodResponseDtoV5,
    DataAnalysisControllerGraphByPeriodError,
    Schemas.GetGraphByPeriodDtoV5,
    {},
    {},
    {}
  >({
    url: '/data-analysis/graph-by-period',
    method: 'post',
    ...variables,
    signal,
  });

export const useDataAnalysisControllerGraphByPeriod = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GraphByPeriodResponseDtoV5,
      DataAnalysisControllerGraphByPeriodError,
      DataAnalysisControllerGraphByPeriodVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GraphByPeriodResponseDtoV5,
    DataAnalysisControllerGraphByPeriodError,
    DataAnalysisControllerGraphByPeriodVariables
  >({
    mutationFn: (variables: DataAnalysisControllerGraphByPeriodVariables) =>
      fetchDataAnalysisControllerGraphByPeriod(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DataAnalysisControllerGraphByRingError =
  Fetcher.ErrorWrapper<undefined>;

export type DataAnalysisControllerGraphByRingVariables = {
  body: Schemas.GetGraphByRingDtoV5;
} & ApiContext['fetcherOptions'];

export const fetchDataAnalysisControllerGraphByRing = (
  variables: DataAnalysisControllerGraphByRingVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GraphByRingResponseDtoV5,
    DataAnalysisControllerGraphByRingError,
    Schemas.GetGraphByRingDtoV5,
    {},
    {},
    {}
  >({
    url: '/data-analysis/graph-by-ring',
    method: 'post',
    ...variables,
    signal,
  });

export const useDataAnalysisControllerGraphByRing = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GraphByRingResponseDtoV5,
      DataAnalysisControllerGraphByRingError,
      DataAnalysisControllerGraphByRingVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GraphByRingResponseDtoV5,
    DataAnalysisControllerGraphByRingError,
    DataAnalysisControllerGraphByRingVariables
  >({
    mutationFn: (variables: DataAnalysisControllerGraphByRingVariables) =>
      fetchDataAnalysisControllerGraphByRing(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DataAnalysisControllerSaveGraphSetError =
  Fetcher.ErrorWrapper<undefined>;

export type DataAnalysisControllerSaveGraphSetVariables = {
  body: Schemas.SaveGraphSetDtoV5;
} & ApiContext['fetcherOptions'];

export const fetchDataAnalysisControllerSaveGraphSet = (
  variables: DataAnalysisControllerSaveGraphSetVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SaveGraphSetResponseDtoV5,
    DataAnalysisControllerSaveGraphSetError,
    Schemas.SaveGraphSetDtoV5,
    {},
    {},
    {}
  >({ url: '/data-analysis/graph-set', method: 'post', ...variables, signal });

export const useDataAnalysisControllerSaveGraphSet = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SaveGraphSetResponseDtoV5,
      DataAnalysisControllerSaveGraphSetError,
      DataAnalysisControllerSaveGraphSetVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SaveGraphSetResponseDtoV5,
    DataAnalysisControllerSaveGraphSetError,
    DataAnalysisControllerSaveGraphSetVariables
  >({
    mutationFn: (variables: DataAnalysisControllerSaveGraphSetVariables) =>
      fetchDataAnalysisControllerSaveGraphSet(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DataAnalysisControllerDuplicateGraphSetPathParams = {
  constructionSiteId: string;
};

export type DataAnalysisControllerDuplicateGraphSetQueryParams = {
  id: string;
};

export type DataAnalysisControllerDuplicateGraphSetError =
  Fetcher.ErrorWrapper<{
    status: 409;
    payload: {
      /**
       * @example 409
       */
      statusCode: number;
      /**
       * @example Conflict
       */
      message: string;
      /**
       * @example Conflict
       */
      error?: string;
    };
  }>;

export type DataAnalysisControllerDuplicateGraphSetVariables = {
  pathParams: DataAnalysisControllerDuplicateGraphSetPathParams;
  queryParams: DataAnalysisControllerDuplicateGraphSetQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDataAnalysisControllerDuplicateGraphSet = (
  variables: DataAnalysisControllerDuplicateGraphSetVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GraphSetStructureDtoV5,
    DataAnalysisControllerDuplicateGraphSetError,
    undefined,
    {},
    DataAnalysisControllerDuplicateGraphSetQueryParams,
    DataAnalysisControllerDuplicateGraphSetPathParams
  >({
    url: '/data-analysis/{constructionSiteId}/duplicate-graph-set',
    method: 'post',
    ...variables,
    signal,
  });

export const useDataAnalysisControllerDuplicateGraphSet = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GraphSetStructureDtoV5,
      DataAnalysisControllerDuplicateGraphSetError,
      DataAnalysisControllerDuplicateGraphSetVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GraphSetStructureDtoV5,
    DataAnalysisControllerDuplicateGraphSetError,
    DataAnalysisControllerDuplicateGraphSetVariables
  >({
    mutationFn: (variables: DataAnalysisControllerDuplicateGraphSetVariables) =>
      fetchDataAnalysisControllerDuplicateGraphSet(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DataAnalysisControllerGetSavedGraphSetPathParams = {
  constructionSiteId: string;
  id: string;
};

export type DataAnalysisControllerGetSavedGraphSetError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: {
    /**
     * @example 404
     */
    statusCode: number;
    /**
     * @example Not Found
     */
    message: string;
    /**
     * @example Not Found
     */
    error?: string;
  };
}>;

export type DataAnalysisControllerGetSavedGraphSetVariables = {
  pathParams: DataAnalysisControllerGetSavedGraphSetPathParams;
} & ApiContext['fetcherOptions'];

export const fetchDataAnalysisControllerGetSavedGraphSet = (
  variables: DataAnalysisControllerGetSavedGraphSetVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GraphSetStructureDtoV5,
    DataAnalysisControllerGetSavedGraphSetError,
    undefined,
    {},
    {},
    DataAnalysisControllerGetSavedGraphSetPathParams
  >({
    url: '/data-analysis/{constructionSiteId}/graph-set/{id}',
    method: 'get',
    ...variables,
    signal,
  });

export function dataAnalysisControllerGetSavedGraphSetQuery(
  variables: DataAnalysisControllerGetSavedGraphSetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.GraphSetStructureDtoV5>;
};

export function dataAnalysisControllerGetSavedGraphSetQuery(
  variables:
    | DataAnalysisControllerGetSavedGraphSetVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.GraphSetStructureDtoV5>)
    | reactQuery.SkipToken;
};

export function dataAnalysisControllerGetSavedGraphSetQuery(
  variables:
    | DataAnalysisControllerGetSavedGraphSetVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/data-analysis/{constructionSiteId}/graph-set/{id}',
      operationId: 'dataAnalysisControllerGetSavedGraphSet',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDataAnalysisControllerGetSavedGraphSet(variables, signal),
  };
}

export const useSuspenseDataAnalysisControllerGetSavedGraphSet = <
  TData = Schemas.GraphSetStructureDtoV5,
>(
  variables: DataAnalysisControllerGetSavedGraphSetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GraphSetStructureDtoV5,
      DataAnalysisControllerGetSavedGraphSetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GraphSetStructureDtoV5,
    DataAnalysisControllerGetSavedGraphSetError,
    TData
  >({
    ...dataAnalysisControllerGetSavedGraphSetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDataAnalysisControllerGetSavedGraphSet = <
  TData = Schemas.GraphSetStructureDtoV5,
>(
  variables:
    | DataAnalysisControllerGetSavedGraphSetVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GraphSetStructureDtoV5,
      DataAnalysisControllerGetSavedGraphSetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GraphSetStructureDtoV5,
    DataAnalysisControllerGetSavedGraphSetError,
    TData
  >({
    ...dataAnalysisControllerGetSavedGraphSetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type GraphSetExportControllerGenerateGraphSetPeriodExportError =
  Fetcher.ErrorWrapper<undefined>;

export type GraphSetExportControllerGenerateGraphSetPeriodExportVariables = {
  body: Schemas.GenerateGraphSetPeriodExportDtoV5;
} & ApiContext['fetcherOptions'];

export const fetchGraphSetExportControllerGenerateGraphSetPeriodExport = (
  variables: GraphSetExportControllerGenerateGraphSetPeriodExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    GraphSetExportControllerGenerateGraphSetPeriodExportError,
    Schemas.GenerateGraphSetPeriodExportDtoV5,
    {},
    {},
    {}
  >({
    url: '/data-analysis/generate-graph-set-period-export',
    method: 'post',
    ...variables,
    signal,
  });

export const useGraphSetExportControllerGenerateGraphSetPeriodExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      GraphSetExportControllerGenerateGraphSetPeriodExportError,
      GraphSetExportControllerGenerateGraphSetPeriodExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    GraphSetExportControllerGenerateGraphSetPeriodExportError,
    GraphSetExportControllerGenerateGraphSetPeriodExportVariables
  >({
    mutationFn: (
      variables: GraphSetExportControllerGenerateGraphSetPeriodExportVariables,
    ) =>
      fetchGraphSetExportControllerGenerateGraphSetPeriodExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type GraphSetExportControllerGenerateGraphSetRingExportError =
  Fetcher.ErrorWrapper<undefined>;

export type GraphSetExportControllerGenerateGraphSetRingExportVariables = {
  body: Schemas.GenerateGraphSetRingExportDtoV5;
} & ApiContext['fetcherOptions'];

export const fetchGraphSetExportControllerGenerateGraphSetRingExport = (
  variables: GraphSetExportControllerGenerateGraphSetRingExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    GraphSetExportControllerGenerateGraphSetRingExportError,
    Schemas.GenerateGraphSetRingExportDtoV5,
    {},
    {},
    {}
  >({
    url: '/data-analysis/generate-graph-set-ring-export',
    method: 'post',
    ...variables,
    signal,
  });

export const useGraphSetExportControllerGenerateGraphSetRingExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      GraphSetExportControllerGenerateGraphSetRingExportError,
      GraphSetExportControllerGenerateGraphSetRingExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    GraphSetExportControllerGenerateGraphSetRingExportError,
    GraphSetExportControllerGenerateGraphSetRingExportVariables
  >({
    mutationFn: (
      variables: GraphSetExportControllerGenerateGraphSetRingExportVariables,
    ) =>
      fetchGraphSetExportControllerGenerateGraphSetRingExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type IndicatorV1ControllerGetIndicatorAnalyzeDataQueryParams = {
  constructionSiteId: string;
  indicatorIds: string[];
  selectedIndicatorIds: string[];
  analysisType: string;
  startDate?: string | null;
  endDate?: string | null;
  startRing?: number | null;
  endRing?: number | null;
};

export type IndicatorV1ControllerGetIndicatorAnalyzeDataError =
  Fetcher.ErrorWrapper<undefined>;

export type IndicatorV1ControllerGetIndicatorAnalyzeDataVariables = {
  queryParams: IndicatorV1ControllerGetIndicatorAnalyzeDataQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchIndicatorV1ControllerGetIndicatorAnalyzeData = (
  variables: IndicatorV1ControllerGetIndicatorAnalyzeDataVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetIndicatorAnalyzeV1ResponseDto,
    IndicatorV1ControllerGetIndicatorAnalyzeDataError,
    undefined,
    {},
    IndicatorV1ControllerGetIndicatorAnalyzeDataQueryParams,
    {}
  >({ url: '/v1/indicator/analyze', method: 'get', ...variables, signal });

export function indicatorV1ControllerGetIndicatorAnalyzeDataQuery(
  variables: IndicatorV1ControllerGetIndicatorAnalyzeDataVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetIndicatorAnalyzeV1ResponseDto>;
};

export function indicatorV1ControllerGetIndicatorAnalyzeDataQuery(
  variables:
    | IndicatorV1ControllerGetIndicatorAnalyzeDataVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetIndicatorAnalyzeV1ResponseDto>)
    | reactQuery.SkipToken;
};

export function indicatorV1ControllerGetIndicatorAnalyzeDataQuery(
  variables:
    | IndicatorV1ControllerGetIndicatorAnalyzeDataVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/indicator/analyze',
      operationId: 'indicatorV1ControllerGetIndicatorAnalyzeData',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchIndicatorV1ControllerGetIndicatorAnalyzeData(
              variables,
              signal,
            ),
  };
}

export const useSuspenseIndicatorV1ControllerGetIndicatorAnalyzeData = <
  TData = Schemas.GetIndicatorAnalyzeV1ResponseDto,
>(
  variables: IndicatorV1ControllerGetIndicatorAnalyzeDataVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetIndicatorAnalyzeV1ResponseDto,
      IndicatorV1ControllerGetIndicatorAnalyzeDataError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetIndicatorAnalyzeV1ResponseDto,
    IndicatorV1ControllerGetIndicatorAnalyzeDataError,
    TData
  >({
    ...indicatorV1ControllerGetIndicatorAnalyzeDataQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useIndicatorV1ControllerGetIndicatorAnalyzeData = <
  TData = Schemas.GetIndicatorAnalyzeV1ResponseDto,
>(
  variables:
    | IndicatorV1ControllerGetIndicatorAnalyzeDataVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetIndicatorAnalyzeV1ResponseDto,
      IndicatorV1ControllerGetIndicatorAnalyzeDataError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetIndicatorAnalyzeV1ResponseDto,
    IndicatorV1ControllerGetIndicatorAnalyzeDataError,
    TData
  >({
    ...indicatorV1ControllerGetIndicatorAnalyzeDataQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type IndicatorV1ControllerIndicatorAnalyzeExportError =
  Fetcher.ErrorWrapper<undefined>;

export type IndicatorV1ControllerIndicatorAnalyzeExportVariables = {
  body: Schemas.GetIndicatorAnalyzeExportV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchIndicatorV1ControllerIndicatorAnalyzeExport = (
  variables: IndicatorV1ControllerIndicatorAnalyzeExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    IndicatorV1ControllerIndicatorAnalyzeExportError,
    Schemas.GetIndicatorAnalyzeExportV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/indicator/analyze/export',
    method: 'post',
    ...variables,
    signal,
  });

export const useIndicatorV1ControllerIndicatorAnalyzeExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      IndicatorV1ControllerIndicatorAnalyzeExportError,
      IndicatorV1ControllerIndicatorAnalyzeExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    IndicatorV1ControllerIndicatorAnalyzeExportError,
    IndicatorV1ControllerIndicatorAnalyzeExportVariables
  >({
    mutationFn: (
      variables: IndicatorV1ControllerIndicatorAnalyzeExportVariables,
    ) =>
      fetchIndicatorV1ControllerIndicatorAnalyzeExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RingListControllerGenerateRingListByDateExportError =
  Fetcher.ErrorWrapper<undefined>;

export type RingListControllerGenerateRingListByDateExportVariables = {
  body: Schemas.GenerageRingListByDateExportDto;
} & ApiContext['fetcherOptions'];

export const fetchRingListControllerGenerateRingListByDateExport = (
  variables: RingListControllerGenerateRingListByDateExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    RingListControllerGenerateRingListByDateExportError,
    Schemas.GenerageRingListByDateExportDto,
    {},
    {},
    {}
  >({
    url: '/production-and-performance/ring-list/export-per-day',
    method: 'post',
    ...variables,
    signal,
  });

export const useRingListControllerGenerateRingListByDateExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      RingListControllerGenerateRingListByDateExportError,
      RingListControllerGenerateRingListByDateExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    RingListControllerGenerateRingListByDateExportError,
    RingListControllerGenerateRingListByDateExportVariables
  >({
    mutationFn: (
      variables: RingListControllerGenerateRingListByDateExportVariables,
    ) =>
      fetchRingListControllerGenerateRingListByDateExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RingListControllerGenerateRingListByRingExportError =
  Fetcher.ErrorWrapper<undefined>;

export type RingListControllerGenerateRingListByRingExportVariables = {
  body: Schemas.GenerageRingListByRingExportDto;
} & ApiContext['fetcherOptions'];

export const fetchRingListControllerGenerateRingListByRingExport = (
  variables: RingListControllerGenerateRingListByRingExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    RingListControllerGenerateRingListByRingExportError,
    Schemas.GenerageRingListByRingExportDto,
    {},
    {},
    {}
  >({
    url: '/production-and-performance/ring-list/export-per-ring',
    method: 'post',
    ...variables,
    signal,
  });

export const useRingListControllerGenerateRingListByRingExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      RingListControllerGenerateRingListByRingExportError,
      RingListControllerGenerateRingListByRingExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    RingListControllerGenerateRingListByRingExportError,
    RingListControllerGenerateRingListByRingExportVariables
  >({
    mutationFn: (
      variables: RingListControllerGenerateRingListByRingExportVariables,
    ) =>
      fetchRingListControllerGenerateRingListByRingExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ProgressHistoryControllerProgressHistoryQueryParams = {
  constructionSiteId: string;
  startDate: string;
  endDate: string;
};

export type ProgressHistoryControllerProgressHistoryError =
  Fetcher.ErrorWrapper<undefined>;

export type ProgressHistoryControllerProgressHistoryVariables = {
  queryParams: ProgressHistoryControllerProgressHistoryQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchProgressHistoryControllerProgressHistory = (
  variables: ProgressHistoryControllerProgressHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetProgressHistoryResponseDto,
    ProgressHistoryControllerProgressHistoryError,
    undefined,
    {},
    ProgressHistoryControllerProgressHistoryQueryParams,
    {}
  >({
    url: '/production-and-performance/progress-history',
    method: 'get',
    ...variables,
    signal,
  });

export function progressHistoryControllerProgressHistoryQuery(
  variables: ProgressHistoryControllerProgressHistoryVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetProgressHistoryResponseDto>;
};

export function progressHistoryControllerProgressHistoryQuery(
  variables:
    | ProgressHistoryControllerProgressHistoryVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetProgressHistoryResponseDto>)
    | reactQuery.SkipToken;
};

export function progressHistoryControllerProgressHistoryQuery(
  variables:
    | ProgressHistoryControllerProgressHistoryVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/production-and-performance/progress-history',
      operationId: 'progressHistoryControllerProgressHistory',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchProgressHistoryControllerProgressHistory(variables, signal),
  };
}

export const useSuspenseProgressHistoryControllerProgressHistory = <
  TData = Schemas.GetProgressHistoryResponseDto,
>(
  variables: ProgressHistoryControllerProgressHistoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetProgressHistoryResponseDto,
      ProgressHistoryControllerProgressHistoryError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetProgressHistoryResponseDto,
    ProgressHistoryControllerProgressHistoryError,
    TData
  >({
    ...progressHistoryControllerProgressHistoryQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useProgressHistoryControllerProgressHistory = <
  TData = Schemas.GetProgressHistoryResponseDto,
>(
  variables:
    | ProgressHistoryControllerProgressHistoryVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetProgressHistoryResponseDto,
      ProgressHistoryControllerProgressHistoryError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetProgressHistoryResponseDto,
    ProgressHistoryControllerProgressHistoryError,
    TData
  >({
    ...progressHistoryControllerProgressHistoryQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingPerDayControllerRingPerDayQueryParams = {
  constructionSiteId: string;
  startDate?: string;
  endDate?: string;
  dayMode: 'shift' | 'calendar';
  startRing?: number;
  endRing?: number;
  legendFilter: string[];
};

export type RingPerDayControllerRingPerDayError =
  Fetcher.ErrorWrapper<undefined>;

export type RingPerDayControllerRingPerDayResponse =
  | (Omit<Schemas.GetCalendarRingPerDayResponseDto, 'dayMode'> & {
      dayMode: 'calendar';
    })
  | (Omit<Schemas.GetShiftRingPerDayResponseDto, 'dayMode'> & {
      dayMode: 'shift';
    });

export type RingPerDayControllerRingPerDayVariables = {
  queryParams: RingPerDayControllerRingPerDayQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRingPerDayControllerRingPerDay = (
  variables: RingPerDayControllerRingPerDayVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    RingPerDayControllerRingPerDayResponse,
    RingPerDayControllerRingPerDayError,
    undefined,
    {},
    RingPerDayControllerRingPerDayQueryParams,
    {}
  >({
    url: '/production-and-performance/ring-per-day',
    method: 'get',
    ...variables,
    signal,
  });

export function ringPerDayControllerRingPerDayQuery(
  variables: RingPerDayControllerRingPerDayVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<RingPerDayControllerRingPerDayResponse>;
};

export function ringPerDayControllerRingPerDayQuery(
  variables: RingPerDayControllerRingPerDayVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<RingPerDayControllerRingPerDayResponse>)
    | reactQuery.SkipToken;
};

export function ringPerDayControllerRingPerDayQuery(
  variables: RingPerDayControllerRingPerDayVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/production-and-performance/ring-per-day',
      operationId: 'ringPerDayControllerRingPerDay',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRingPerDayControllerRingPerDay(variables, signal),
  };
}

export const useSuspenseRingPerDayControllerRingPerDay = <
  TData = RingPerDayControllerRingPerDayResponse,
>(
  variables: RingPerDayControllerRingPerDayVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      RingPerDayControllerRingPerDayResponse,
      RingPerDayControllerRingPerDayError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    RingPerDayControllerRingPerDayResponse,
    RingPerDayControllerRingPerDayError,
    TData
  >({
    ...ringPerDayControllerRingPerDayQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRingPerDayControllerRingPerDay = <
  TData = RingPerDayControllerRingPerDayResponse,
>(
  variables: RingPerDayControllerRingPerDayVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      RingPerDayControllerRingPerDayResponse,
      RingPerDayControllerRingPerDayError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    RingPerDayControllerRingPerDayResponse,
    RingPerDayControllerRingPerDayError,
    TData
  >({
    ...ringPerDayControllerRingPerDayQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingPerDayControllerGenerateRingPerDayExportError =
  Fetcher.ErrorWrapper<undefined>;

export type RingPerDayControllerGenerateRingPerDayExportVariables = {
  body: Schemas.RingPerDayExportInputDto;
} & ApiContext['fetcherOptions'];

export const fetchRingPerDayControllerGenerateRingPerDayExport = (
  variables: RingPerDayControllerGenerateRingPerDayExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    RingPerDayControllerGenerateRingPerDayExportError,
    Schemas.RingPerDayExportInputDto,
    {},
    {},
    {}
  >({
    url: '/production-and-performance/ring-per-day/export',
    method: 'post',
    ...variables,
    signal,
  });

export const useRingPerDayControllerGenerateRingPerDayExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      RingPerDayControllerGenerateRingPerDayExportError,
      RingPerDayControllerGenerateRingPerDayExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    RingPerDayControllerGenerateRingPerDayExportError,
    RingPerDayControllerGenerateRingPerDayExportVariables
  >({
    mutationFn: (
      variables: RingPerDayControllerGenerateRingPerDayExportVariables,
    ) =>
      fetchRingPerDayControllerGenerateRingPerDayExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQueryParams =
  {
    constructionSiteId: string;
    startDate?: string;
    endDate?: string;
    dayMode: 'shift' | 'calendar';
    startRing?: number;
    endRing?: number;
  };

export type ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationError =
  Fetcher.ErrorWrapper<undefined>;

export type ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables =
  {
    queryParams: ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQueryParams;
  } & ApiContext['fetcherOptions'];

export const fetchExcavationAndBuildingDurationControllerGetExcavationAndBuildingDuration =
  (
    variables: ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables,
    signal?: AbortSignal,
  ) =>
    apiFetch<
      Schemas.GetExcavationAndBuildingDurationResponseDto,
      ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationError,
      undefined,
      {},
      ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQueryParams,
      {}
    >({
      url: '/production-and-performance/excavation-and-building-duration',
      method: 'get',
      ...variables,
      signal,
    });

export function excavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQuery(
  variables: ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetExcavationAndBuildingDurationResponseDto>;
};

export function excavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQuery(
  variables:
    | ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetExcavationAndBuildingDurationResponseDto>)
    | reactQuery.SkipToken;
};

export function excavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQuery(
  variables:
    | ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/production-and-performance/excavation-and-building-duration',
      operationId:
        'excavationAndBuildingDurationControllerGetExcavationAndBuildingDuration',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchExcavationAndBuildingDurationControllerGetExcavationAndBuildingDuration(
              variables,
              signal,
            ),
  };
}

export const useSuspenseExcavationAndBuildingDurationControllerGetExcavationAndBuildingDuration =
  <TData = Schemas.GetExcavationAndBuildingDurationResponseDto,>(
    variables: ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.GetExcavationAndBuildingDurationResponseDto,
        ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationError,
        TData
      >,
      'queryKey' | 'queryFn' | 'initialData'
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useApiContext(options);
    return reactQuery.useSuspenseQuery<
      Schemas.GetExcavationAndBuildingDurationResponseDto,
      ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationError,
      TData
    >({
      ...excavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQuery(
        deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export const useExcavationAndBuildingDurationControllerGetExcavationAndBuildingDuration =
  <TData = Schemas.GetExcavationAndBuildingDurationResponseDto,>(
    variables:
      | ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables
      | reactQuery.SkipToken,
    options?: Omit<
      reactQuery.UseQueryOptions<
        Schemas.GetExcavationAndBuildingDurationResponseDto,
        ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationError,
        TData
      >,
      'queryKey' | 'queryFn' | 'initialData'
    >,
  ) => {
    const { queryOptions, fetcherOptions } = useApiContext(options);
    return reactQuery.useQuery<
      Schemas.GetExcavationAndBuildingDurationResponseDto,
      ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationError,
      TData
    >({
      ...excavationAndBuildingDurationControllerGetExcavationAndBuildingDurationQuery(
        variables === reactQuery.skipToken
          ? variables
          : deepMerge(fetcherOptions, variables),
      ),
      ...options,
      ...queryOptions,
    });
  };

export type ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportError =
  Fetcher.ErrorWrapper<undefined>;

export type ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportVariables =
  {
    body: Schemas.ExcavationAndBuildingDurationExportInputDto;
  } & ApiContext['fetcherOptions'];

export const fetchExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExport =
  (
    variables: ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportVariables,
    signal?: AbortSignal,
  ) =>
    apiFetch<
      Schemas.ExcavationAndBuildingDurationExportResponseDto,
      ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportError,
      Schemas.ExcavationAndBuildingDurationExportInputDto,
      {},
      {},
      {}
    >({
      url: '/production-and-performance/excavation-and-building-duration/export',
      method: 'post',
      ...variables,
      signal,
    });

export const useExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExport =
  (
    options?: Omit<
      reactQuery.UseMutationOptions<
        Schemas.ExcavationAndBuildingDurationExportResponseDto,
        ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportError,
        ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportVariables
      >,
      'mutationFn'
    >,
  ) => {
    const { fetcherOptions } = useApiContext();
    return reactQuery.useMutation<
      Schemas.ExcavationAndBuildingDurationExportResponseDto,
      ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportError,
      ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportVariables
    >({
      mutationFn: (
        variables: ExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExportVariables,
      ) =>
        fetchExcavationAndBuildingDurationControllerGenerateExcavationAndBuildingDurationExport(
          deepMerge(fetcherOptions, variables),
        ),
      ...options,
    });
  };

export type PlanningControllerImportPlanningError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: {
    /**
     * @example 400
     */
    statusCode: number;
    /**
     * @example Validation failed: invalid planning file
     */
    message: string;
    /**
     * @example INVALID_PLANNING_FILE
     */
    error?: string;
  };
}>;

export type PlanningControllerImportPlanningRequestBody = {
  constructionSiteId: string;
  /**
   * @format binary
   */
  file: Blob;
};

export type PlanningControllerImportPlanningVariables = {
  body: PlanningControllerImportPlanningRequestBody;
} & ApiContext['fetcherOptions'];

export const fetchPlanningControllerImportPlanning = (
  variables: PlanningControllerImportPlanningVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    PlanningControllerImportPlanningError,
    PlanningControllerImportPlanningRequestBody,
    {},
    {},
    {}
  >({
    url: '/production-and-performance/planning/import',
    method: 'post',
    ...variables,
    signal,
  });

export const usePlanningControllerImportPlanning = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      PlanningControllerImportPlanningError,
      PlanningControllerImportPlanningVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    PlanningControllerImportPlanningError,
    PlanningControllerImportPlanningVariables
  >({
    mutationFn: (variables: PlanningControllerImportPlanningVariables) =>
      fetchPlanningControllerImportPlanning(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type PlanningControllerGeneratePlanningExportError =
  Fetcher.ErrorWrapper<undefined>;

export type PlanningControllerGeneratePlanningExportVariables = {
  body: Schemas.PlanningExportInputDto;
} & ApiContext['fetcherOptions'];

export const fetchPlanningControllerGeneratePlanningExport = (
  variables: PlanningControllerGeneratePlanningExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    PlanningControllerGeneratePlanningExportError,
    Schemas.PlanningExportInputDto,
    {},
    {},
    {}
  >({
    url: '/production-and-performance/planning/export',
    method: 'post',
    ...variables,
    signal,
  });

export const usePlanningControllerGeneratePlanningExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      PlanningControllerGeneratePlanningExportError,
      PlanningControllerGeneratePlanningExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    PlanningControllerGeneratePlanningExportError,
    PlanningControllerGeneratePlanningExportVariables
  >({
    mutationFn: (
      variables: PlanningControllerGeneratePlanningExportVariables,
    ) =>
      fetchPlanningControllerGeneratePlanningExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type PlanningControllerGetPlanningQueryParams = {
  constructionSiteId: string;
  startDate?: string | null;
  endDate?: string | null;
  startRing?: number | null;
  endRing?: number | null;
  withProjection?: boolean | null;
};

export type PlanningControllerGetPlanningError =
  Fetcher.ErrorWrapper<undefined>;

export type PlanningControllerGetPlanningVariables = {
  queryParams: PlanningControllerGetPlanningQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchPlanningControllerGetPlanning = (
  variables: PlanningControllerGetPlanningVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetPlanningResponseDto,
    PlanningControllerGetPlanningError,
    undefined,
    {},
    PlanningControllerGetPlanningQueryParams,
    {}
  >({
    url: '/production-and-performance/planning',
    method: 'get',
    ...variables,
    signal,
  });

export function planningControllerGetPlanningQuery(
  variables: PlanningControllerGetPlanningVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.GetPlanningResponseDto>;
};

export function planningControllerGetPlanningQuery(
  variables: PlanningControllerGetPlanningVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.GetPlanningResponseDto>)
    | reactQuery.SkipToken;
};

export function planningControllerGetPlanningQuery(
  variables: PlanningControllerGetPlanningVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/production-and-performance/planning',
      operationId: 'planningControllerGetPlanning',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchPlanningControllerGetPlanning(variables, signal),
  };
}

export const useSuspensePlanningControllerGetPlanning = <
  TData = Schemas.GetPlanningResponseDto,
>(
  variables: PlanningControllerGetPlanningVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetPlanningResponseDto,
      PlanningControllerGetPlanningError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetPlanningResponseDto,
    PlanningControllerGetPlanningError,
    TData
  >({
    ...planningControllerGetPlanningQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePlanningControllerGetPlanning = <
  TData = Schemas.GetPlanningResponseDto,
>(
  variables: PlanningControllerGetPlanningVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetPlanningResponseDto,
      PlanningControllerGetPlanningError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetPlanningResponseDto,
    PlanningControllerGetPlanningError,
    TData
  >({
    ...planningControllerGetPlanningQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type BoardConfigV1ControllerGetPathParams = {
  constructionSiteId: string;
};

export type BoardConfigV1ControllerGetError = Fetcher.ErrorWrapper<undefined>;

export type BoardConfigV1ControllerGetVariables = {
  pathParams: BoardConfigV1ControllerGetPathParams;
} & ApiContext['fetcherOptions'];

export const fetchBoardConfigV1ControllerGet = (
  variables: BoardConfigV1ControllerGetVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BoardConfigV1OutputDto,
    BoardConfigV1ControllerGetError,
    undefined,
    {},
    {},
    BoardConfigV1ControllerGetPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/board-config',
    method: 'get',
    ...variables,
    signal,
  });

export function boardConfigV1ControllerGetQuery(
  variables: BoardConfigV1ControllerGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.BoardConfigV1OutputDto>;
};

export function boardConfigV1ControllerGetQuery(
  variables: BoardConfigV1ControllerGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.BoardConfigV1OutputDto>)
    | reactQuery.SkipToken;
};

export function boardConfigV1ControllerGetQuery(
  variables: BoardConfigV1ControllerGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/board-config',
      operationId: 'boardConfigV1ControllerGet',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchBoardConfigV1ControllerGet(variables, signal),
  };
}

export const useSuspenseBoardConfigV1ControllerGet = <
  TData = Schemas.BoardConfigV1OutputDto,
>(
  variables: BoardConfigV1ControllerGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BoardConfigV1OutputDto,
      BoardConfigV1ControllerGetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.BoardConfigV1OutputDto,
    BoardConfigV1ControllerGetError,
    TData
  >({
    ...boardConfigV1ControllerGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBoardConfigV1ControllerGet = <
  TData = Schemas.BoardConfigV1OutputDto,
>(
  variables: BoardConfigV1ControllerGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BoardConfigV1OutputDto,
      BoardConfigV1ControllerGetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.BoardConfigV1OutputDto,
    BoardConfigV1ControllerGetError,
    TData
  >({
    ...boardConfigV1ControllerGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type BoardViewerConfigV1ControllerGetPathParams = {
  constructionSiteId: string;
};

export type BoardViewerConfigV1ControllerGetError =
  Fetcher.ErrorWrapper<undefined>;

export type BoardViewerConfigV1ControllerGetVariables = {
  pathParams: BoardViewerConfigV1ControllerGetPathParams;
} & ApiContext['fetcherOptions'];

export const fetchBoardViewerConfigV1ControllerGet = (
  variables: BoardViewerConfigV1ControllerGetVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BoardViewerConfigV1OutputDto,
    BoardViewerConfigV1ControllerGetError,
    undefined,
    {},
    {},
    BoardViewerConfigV1ControllerGetPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/board-viewer-config',
    method: 'get',
    ...variables,
    signal,
  });

export function boardViewerConfigV1ControllerGetQuery(
  variables: BoardViewerConfigV1ControllerGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.BoardViewerConfigV1OutputDto>;
};

export function boardViewerConfigV1ControllerGetQuery(
  variables: BoardViewerConfigV1ControllerGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.BoardViewerConfigV1OutputDto>)
    | reactQuery.SkipToken;
};

export function boardViewerConfigV1ControllerGetQuery(
  variables: BoardViewerConfigV1ControllerGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/board-viewer-config',
      operationId: 'boardViewerConfigV1ControllerGet',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchBoardViewerConfigV1ControllerGet(variables, signal),
  };
}

export const useSuspenseBoardViewerConfigV1ControllerGet = <
  TData = Schemas.BoardViewerConfigV1OutputDto,
>(
  variables: BoardViewerConfigV1ControllerGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BoardViewerConfigV1OutputDto,
      BoardViewerConfigV1ControllerGetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.BoardViewerConfigV1OutputDto,
    BoardViewerConfigV1ControllerGetError,
    TData
  >({
    ...boardViewerConfigV1ControllerGetQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useBoardViewerConfigV1ControllerGet = <
  TData = Schemas.BoardViewerConfigV1OutputDto,
>(
  variables: BoardViewerConfigV1ControllerGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BoardViewerConfigV1OutputDto,
      BoardViewerConfigV1ControllerGetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.BoardViewerConfigV1OutputDto,
    BoardViewerConfigV1ControllerGetError,
    TData
  >({
    ...boardViewerConfigV1ControllerGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RecordSegmentDefectV1ControllerGetRangeStatsPathParams = {
  constructionSiteId: string;
};

export type RecordSegmentDefectV1ControllerGetRangeStatsQueryParams = {
  startRing: number;
  endRing: number;
};

export type RecordSegmentDefectV1ControllerGetRangeStatsError =
  Fetcher.ErrorWrapper<undefined>;

export type RecordSegmentDefectV1ControllerGetRangeStatsVariables = {
  pathParams: RecordSegmentDefectV1ControllerGetRangeStatsPathParams;
  queryParams: RecordSegmentDefectV1ControllerGetRangeStatsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRecordSegmentDefectV1ControllerGetRangeStats = (
  variables: RecordSegmentDefectV1ControllerGetRangeStatsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto,
    RecordSegmentDefectV1ControllerGetRangeStatsError,
    undefined,
    {},
    RecordSegmentDefectV1ControllerGetRangeStatsQueryParams,
    RecordSegmentDefectV1ControllerGetRangeStatsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/record-segment-defect/range-stats',
    method: 'get',
    ...variables,
    signal,
  });

export function recordSegmentDefectV1ControllerGetRangeStatsQuery(
  variables: RecordSegmentDefectV1ControllerGetRangeStatsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto>;
};

export function recordSegmentDefectV1ControllerGetRangeStatsQuery(
  variables:
    | RecordSegmentDefectV1ControllerGetRangeStatsVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto>)
    | reactQuery.SkipToken;
};

export function recordSegmentDefectV1ControllerGetRangeStatsQuery(
  variables:
    | RecordSegmentDefectV1ControllerGetRangeStatsVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/record-segment-defect/range-stats',
      operationId: 'recordSegmentDefectV1ControllerGetRangeStats',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRecordSegmentDefectV1ControllerGetRangeStats(
              variables,
              signal,
            ),
  };
}

export const useSuspenseRecordSegmentDefectV1ControllerGetRangeStats = <
  TData = Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto,
>(
  variables: RecordSegmentDefectV1ControllerGetRangeStatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto,
      RecordSegmentDefectV1ControllerGetRangeStatsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto,
    RecordSegmentDefectV1ControllerGetRangeStatsError,
    TData
  >({
    ...recordSegmentDefectV1ControllerGetRangeStatsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRecordSegmentDefectV1ControllerGetRangeStats = <
  TData = Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto,
>(
  variables:
    | RecordSegmentDefectV1ControllerGetRangeStatsVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto,
      RecordSegmentDefectV1ControllerGetRangeStatsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetRecordSegmentDefectRangeStatsV1OutputDto,
    RecordSegmentDefectV1ControllerGetRangeStatsError,
    TData
  >({
    ...recordSegmentDefectV1ControllerGetRangeStatsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentHistoryV1ControllerGetSegmentsHistoryPathParams = {
  constructionSiteId: string;
};

export type SegmentHistoryV1ControllerGetSegmentsHistoryQueryParams = {
  serialNumber?: string | null;
  scanSite?: string | null;
  segmentType?: string | null;
  status?: string[];
  segmentDate?: string | null;
  /**
   * @format date-time
   */
  segmentDateStart?: string | null;
  /**
   * @format date-time
   */
  segmentDateEnd?: string | null;
  lastScanRange?: string | null;
  ringNumberStart?: number | null;
  ringNumberEnd?: number | null;
  paginationPage?: number | null;
  paginationSize?: number | null;
  paginationSortField?: string | null;
  paginationSortDirection?: string | null;
};

export type SegmentHistoryV1ControllerGetSegmentsHistoryError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentHistoryV1ControllerGetSegmentsHistoryVariables = {
  pathParams: SegmentHistoryV1ControllerGetSegmentsHistoryPathParams;
  queryParams?: SegmentHistoryV1ControllerGetSegmentsHistoryQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentHistoryV1ControllerGetSegmentsHistory = (
  variables: SegmentHistoryV1ControllerGetSegmentsHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentHistoryEntriesV1OutputDto,
    SegmentHistoryV1ControllerGetSegmentsHistoryError,
    undefined,
    {},
    SegmentHistoryV1ControllerGetSegmentsHistoryQueryParams,
    SegmentHistoryV1ControllerGetSegmentsHistoryPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/segments/history',
    method: 'get',
    ...variables,
    signal,
  });

export function segmentHistoryV1ControllerGetSegmentsHistoryQuery(
  variables: SegmentHistoryV1ControllerGetSegmentsHistoryVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.SegmentHistoryEntriesV1OutputDto>;
};

export function segmentHistoryV1ControllerGetSegmentsHistoryQuery(
  variables:
    | SegmentHistoryV1ControllerGetSegmentsHistoryVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.SegmentHistoryEntriesV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentHistoryV1ControllerGetSegmentsHistoryQuery(
  variables:
    | SegmentHistoryV1ControllerGetSegmentsHistoryVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/segments/history',
      operationId: 'segmentHistoryV1ControllerGetSegmentsHistory',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentHistoryV1ControllerGetSegmentsHistory(
              variables,
              signal,
            ),
  };
}

export const useSuspenseSegmentHistoryV1ControllerGetSegmentsHistory = <
  TData = Schemas.SegmentHistoryEntriesV1OutputDto,
>(
  variables: SegmentHistoryV1ControllerGetSegmentsHistoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentHistoryEntriesV1OutputDto,
      SegmentHistoryV1ControllerGetSegmentsHistoryError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentHistoryEntriesV1OutputDto,
    SegmentHistoryV1ControllerGetSegmentsHistoryError,
    TData
  >({
    ...segmentHistoryV1ControllerGetSegmentsHistoryQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentHistoryV1ControllerGetSegmentsHistory = <
  TData = Schemas.SegmentHistoryEntriesV1OutputDto,
>(
  variables:
    | SegmentHistoryV1ControllerGetSegmentsHistoryVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentHistoryEntriesV1OutputDto,
      SegmentHistoryV1ControllerGetSegmentsHistoryError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentHistoryEntriesV1OutputDto,
    SegmentHistoryV1ControllerGetSegmentsHistoryError,
    TData
  >({
    ...segmentHistoryV1ControllerGetSegmentsHistoryQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentHistoryV1ControllerExportSegmentsPathParams = {
  constructionSiteId: string;
};

export type SegmentHistoryV1ControllerExportSegmentsError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentHistoryV1ControllerExportSegmentsVariables = {
  body: Schemas.SegmentHistoryExportV1InputDto;
  pathParams: SegmentHistoryV1ControllerExportSegmentsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentHistoryV1ControllerExportSegments = (
  variables: SegmentHistoryV1ControllerExportSegmentsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    SegmentHistoryV1ControllerExportSegmentsError,
    Schemas.SegmentHistoryExportV1InputDto,
    {},
    {},
    SegmentHistoryV1ControllerExportSegmentsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/segments/history/export-segments',
    method: 'post',
    ...variables,
    signal,
  });

export const useSegmentHistoryV1ControllerExportSegments = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      SegmentHistoryV1ControllerExportSegmentsError,
      SegmentHistoryV1ControllerExportSegmentsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    SegmentHistoryV1ControllerExportSegmentsError,
    SegmentHistoryV1ControllerExportSegmentsVariables
  >({
    mutationFn: (
      variables: SegmentHistoryV1ControllerExportSegmentsVariables,
    ) =>
      fetchSegmentHistoryV1ControllerExportSegments(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentHistoryV1ControllerExportSegmentsHistoryPathParams = {
  constructionSiteId: string;
};

export type SegmentHistoryV1ControllerExportSegmentsHistoryError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentHistoryV1ControllerExportSegmentsHistoryVariables = {
  body: Schemas.SegmentHistoryExportV1InputDto;
  pathParams: SegmentHistoryV1ControllerExportSegmentsHistoryPathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentHistoryV1ControllerExportSegmentsHistory = (
  variables: SegmentHistoryV1ControllerExportSegmentsHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    SegmentHistoryV1ControllerExportSegmentsHistoryError,
    Schemas.SegmentHistoryExportV1InputDto,
    {},
    {},
    SegmentHistoryV1ControllerExportSegmentsHistoryPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/segments/history/export-segment-history',
    method: 'post',
    ...variables,
    signal,
  });

export const useSegmentHistoryV1ControllerExportSegmentsHistory = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      SegmentHistoryV1ControllerExportSegmentsHistoryError,
      SegmentHistoryV1ControllerExportSegmentsHistoryVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    SegmentHistoryV1ControllerExportSegmentsHistoryError,
    SegmentHistoryV1ControllerExportSegmentsHistoryVariables
  >({
    mutationFn: (
      variables: SegmentHistoryV1ControllerExportSegmentsHistoryVariables,
    ) =>
      fetchSegmentHistoryV1ControllerExportSegmentsHistory(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentHistoryV1ControllerCreateManualSegmentHistoryError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentHistoryV1ControllerCreateManualSegmentHistoryVariables = {
  body: Schemas.SegmentHistoryCreateV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchSegmentHistoryV1ControllerCreateManualSegmentHistory = (
  variables: SegmentHistoryV1ControllerCreateManualSegmentHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentHistoryCreateV1InputDto,
    SegmentHistoryV1ControllerCreateManualSegmentHistoryError,
    Schemas.SegmentHistoryCreateV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/quality/segments/history',
    method: 'post',
    ...variables,
    signal,
  });

export const useSegmentHistoryV1ControllerCreateManualSegmentHistory = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SegmentHistoryCreateV1InputDto,
      SegmentHistoryV1ControllerCreateManualSegmentHistoryError,
      SegmentHistoryV1ControllerCreateManualSegmentHistoryVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SegmentHistoryCreateV1InputDto,
    SegmentHistoryV1ControllerCreateManualSegmentHistoryError,
    SegmentHistoryV1ControllerCreateManualSegmentHistoryVariables
  >({
    mutationFn: (
      variables: SegmentHistoryV1ControllerCreateManualSegmentHistoryVariables,
    ) =>
      fetchSegmentHistoryV1ControllerCreateManualSegmentHistory(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentHistoryV1ControllerDeleteSegmentHistoryError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentHistoryV1ControllerDeleteSegmentHistoryVariables = {
  body: Schemas.SegmentHistoryDeleteV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchSegmentHistoryV1ControllerDeleteSegmentHistory = (
  variables: SegmentHistoryV1ControllerDeleteSegmentHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentHistoryDeleteV1OutputDto,
    SegmentHistoryV1ControllerDeleteSegmentHistoryError,
    Schemas.SegmentHistoryDeleteV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/quality/segments/history',
    method: 'delete',
    ...variables,
    signal,
  });

export const useSegmentHistoryV1ControllerDeleteSegmentHistory = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SegmentHistoryDeleteV1OutputDto,
      SegmentHistoryV1ControllerDeleteSegmentHistoryError,
      SegmentHistoryV1ControllerDeleteSegmentHistoryVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SegmentHistoryDeleteV1OutputDto,
    SegmentHistoryV1ControllerDeleteSegmentHistoryError,
    SegmentHistoryV1ControllerDeleteSegmentHistoryVariables
  >({
    mutationFn: (
      variables: SegmentHistoryV1ControllerDeleteSegmentHistoryVariables,
    ) =>
      fetchSegmentHistoryV1ControllerDeleteSegmentHistory(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentHistoryV1ControllerBulkUpdateStatusPathParams = {
  constructionSiteId: string;
};

export type SegmentHistoryV1ControllerBulkUpdateStatusError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentHistoryV1ControllerBulkUpdateStatusVariables = {
  body: Schemas.BulkStatusUpdateV1InputDto;
  pathParams: SegmentHistoryV1ControllerBulkUpdateStatusPathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentHistoryV1ControllerBulkUpdateStatus = (
  variables: SegmentHistoryV1ControllerBulkUpdateStatusVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BulkStatusUpdateV1OutputDto,
    SegmentHistoryV1ControllerBulkUpdateStatusError,
    Schemas.BulkStatusUpdateV1InputDto,
    {},
    {},
    SegmentHistoryV1ControllerBulkUpdateStatusPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/segments/history/bulk-status-update',
    method: 'post',
    ...variables,
    signal,
  });

export const useSegmentHistoryV1ControllerBulkUpdateStatus = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BulkStatusUpdateV1OutputDto,
      SegmentHistoryV1ControllerBulkUpdateStatusError,
      SegmentHistoryV1ControllerBulkUpdateStatusVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BulkStatusUpdateV1OutputDto,
    SegmentHistoryV1ControllerBulkUpdateStatusError,
    SegmentHistoryV1ControllerBulkUpdateStatusVariables
  >({
    mutationFn: (
      variables: SegmentHistoryV1ControllerBulkUpdateStatusVariables,
    ) =>
      fetchSegmentHistoryV1ControllerBulkUpdateStatus(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type QuarantineDefectV1ControllerUpdateDefectDetailsPathParams = {
  defectId: string;
};

export type QuarantineDefectV1ControllerUpdateDefectDetailsError =
  Fetcher.ErrorWrapper<undefined>;

export type QuarantineDefectV1ControllerUpdateDefectDetailsVariables = {
  body: Schemas.QuarantineDefectV1UpdateInputDto;
  pathParams: QuarantineDefectV1ControllerUpdateDefectDetailsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchQuarantineDefectV1ControllerUpdateDefectDetails = (
  variables: QuarantineDefectV1ControllerUpdateDefectDetailsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QuarantineDefectV1UpdateOutputDto,
    QuarantineDefectV1ControllerUpdateDefectDetailsError,
    Schemas.QuarantineDefectV1UpdateInputDto,
    {},
    {},
    QuarantineDefectV1ControllerUpdateDefectDetailsPathParams
  >({
    url: '/v1/quality/quarantine-defect/{defectId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useQuarantineDefectV1ControllerUpdateDefectDetails = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.QuarantineDefectV1UpdateOutputDto,
      QuarantineDefectV1ControllerUpdateDefectDetailsError,
      QuarantineDefectV1ControllerUpdateDefectDetailsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.QuarantineDefectV1UpdateOutputDto,
    QuarantineDefectV1ControllerUpdateDefectDetailsError,
    QuarantineDefectV1ControllerUpdateDefectDetailsVariables
  >({
    mutationFn: (
      variables: QuarantineDefectV1ControllerUpdateDefectDetailsVariables,
    ) =>
      fetchQuarantineDefectV1ControllerUpdateDefectDetails(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type QuarantineDefectV1ControllerUpdateRepairDetailsPathParams = {
  defectId: string;
};

export type QuarantineDefectV1ControllerUpdateRepairDetailsError =
  Fetcher.ErrorWrapper<undefined>;

export type QuarantineDefectV1ControllerUpdateRepairDetailsVariables = {
  body: Schemas.DefectRepairV1UpdateInputDto;
  pathParams: QuarantineDefectV1ControllerUpdateRepairDetailsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchQuarantineDefectV1ControllerUpdateRepairDetails = (
  variables: QuarantineDefectV1ControllerUpdateRepairDetailsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectRepairV1UpdateOutputDto,
    QuarantineDefectV1ControllerUpdateRepairDetailsError,
    Schemas.DefectRepairV1UpdateInputDto,
    {},
    {},
    QuarantineDefectV1ControllerUpdateRepairDetailsPathParams
  >({
    url: '/v1/quality/quarantine-defect/{defectId}/repair',
    method: 'put',
    ...variables,
    signal,
  });

export const useQuarantineDefectV1ControllerUpdateRepairDetails = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DefectRepairV1UpdateOutputDto,
      QuarantineDefectV1ControllerUpdateRepairDetailsError,
      QuarantineDefectV1ControllerUpdateRepairDetailsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DefectRepairV1UpdateOutputDto,
    QuarantineDefectV1ControllerUpdateRepairDetailsError,
    QuarantineDefectV1ControllerUpdateRepairDetailsVariables
  >({
    mutationFn: (
      variables: QuarantineDefectV1ControllerUpdateRepairDetailsVariables,
    ) =>
      fetchQuarantineDefectV1ControllerUpdateRepairDetails(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ScanConfigV1ControllerGetByConstructionSiteQueryParams = {
  constructionSiteId: string;
};

export type ScanConfigV1ControllerGetByConstructionSiteError =
  Fetcher.ErrorWrapper<undefined>;

export type ScanConfigV1ControllerGetByConstructionSiteVariables = {
  queryParams: ScanConfigV1ControllerGetByConstructionSiteQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchScanConfigV1ControllerGetByConstructionSite = (
  variables: ScanConfigV1ControllerGetByConstructionSiteVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ScanConfigV1OutputDto,
    ScanConfigV1ControllerGetByConstructionSiteError,
    undefined,
    {},
    ScanConfigV1ControllerGetByConstructionSiteQueryParams,
    {}
  >({ url: '/v1/quality/scan-config', method: 'get', ...variables, signal });

export function scanConfigV1ControllerGetByConstructionSiteQuery(
  variables: ScanConfigV1ControllerGetByConstructionSiteVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ScanConfigV1OutputDto>;
};

export function scanConfigV1ControllerGetByConstructionSiteQuery(
  variables:
    | ScanConfigV1ControllerGetByConstructionSiteVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ScanConfigV1OutputDto>)
    | reactQuery.SkipToken;
};

export function scanConfigV1ControllerGetByConstructionSiteQuery(
  variables:
    | ScanConfigV1ControllerGetByConstructionSiteVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/scan-config',
      operationId: 'scanConfigV1ControllerGetByConstructionSite',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchScanConfigV1ControllerGetByConstructionSite(variables, signal),
  };
}

export const useSuspenseScanConfigV1ControllerGetByConstructionSite = <
  TData = Schemas.ScanConfigV1OutputDto,
>(
  variables: ScanConfigV1ControllerGetByConstructionSiteVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanConfigV1OutputDto,
      ScanConfigV1ControllerGetByConstructionSiteError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ScanConfigV1OutputDto,
    ScanConfigV1ControllerGetByConstructionSiteError,
    TData
  >({
    ...scanConfigV1ControllerGetByConstructionSiteQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useScanConfigV1ControllerGetByConstructionSite = <
  TData = Schemas.ScanConfigV1OutputDto,
>(
  variables:
    | ScanConfigV1ControllerGetByConstructionSiteVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanConfigV1OutputDto,
      ScanConfigV1ControllerGetByConstructionSiteError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.ScanConfigV1OutputDto,
    ScanConfigV1ControllerGetByConstructionSiteError,
    TData
  >({
    ...scanConfigV1ControllerGetByConstructionSiteQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type QuarantineDefectPictureV1ControllerGetByDefectQueryParams = {
  defectId: string;
};

export type QuarantineDefectPictureV1ControllerGetByDefectError =
  Fetcher.ErrorWrapper<undefined>;

export type QuarantineDefectPictureV1ControllerGetByDefectVariables = {
  queryParams: QuarantineDefectPictureV1ControllerGetByDefectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchQuarantineDefectPictureV1ControllerGetByDefect = (
  variables: QuarantineDefectPictureV1ControllerGetByDefectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QuarantineDefectPictureV1OutputDto,
    QuarantineDefectPictureV1ControllerGetByDefectError,
    undefined,
    {},
    QuarantineDefectPictureV1ControllerGetByDefectQueryParams,
    {}
  >({
    url: '/v1/quality/quarantine-defect-picture',
    method: 'get',
    ...variables,
    signal,
  });

export function quarantineDefectPictureV1ControllerGetByDefectQuery(
  variables: QuarantineDefectPictureV1ControllerGetByDefectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.QuarantineDefectPictureV1OutputDto>;
};

export function quarantineDefectPictureV1ControllerGetByDefectQuery(
  variables:
    | QuarantineDefectPictureV1ControllerGetByDefectVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.QuarantineDefectPictureV1OutputDto>)
    | reactQuery.SkipToken;
};

export function quarantineDefectPictureV1ControllerGetByDefectQuery(
  variables:
    | QuarantineDefectPictureV1ControllerGetByDefectVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/quarantine-defect-picture',
      operationId: 'quarantineDefectPictureV1ControllerGetByDefect',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchQuarantineDefectPictureV1ControllerGetByDefect(
              variables,
              signal,
            ),
  };
}

export const useSuspenseQuarantineDefectPictureV1ControllerGetByDefect = <
  TData = Schemas.QuarantineDefectPictureV1OutputDto,
>(
  variables: QuarantineDefectPictureV1ControllerGetByDefectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuarantineDefectPictureV1OutputDto,
      QuarantineDefectPictureV1ControllerGetByDefectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.QuarantineDefectPictureV1OutputDto,
    QuarantineDefectPictureV1ControllerGetByDefectError,
    TData
  >({
    ...quarantineDefectPictureV1ControllerGetByDefectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useQuarantineDefectPictureV1ControllerGetByDefect = <
  TData = Schemas.QuarantineDefectPictureV1OutputDto,
>(
  variables:
    | QuarantineDefectPictureV1ControllerGetByDefectVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuarantineDefectPictureV1OutputDto,
      QuarantineDefectPictureV1ControllerGetByDefectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.QuarantineDefectPictureV1OutputDto,
    QuarantineDefectPictureV1ControllerGetByDefectError,
    TData
  >({
    ...quarantineDefectPictureV1ControllerGetByDefectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DefectRepairPictureV1ControllerGetByRepairQueryParams = {
  repairId: string;
};

export type DefectRepairPictureV1ControllerGetByRepairError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectRepairPictureV1ControllerGetByRepairVariables = {
  queryParams: DefectRepairPictureV1ControllerGetByRepairQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectRepairPictureV1ControllerGetByRepair = (
  variables: DefectRepairPictureV1ControllerGetByRepairVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectRepairPictureV1OutputDto,
    DefectRepairPictureV1ControllerGetByRepairError,
    undefined,
    {},
    DefectRepairPictureV1ControllerGetByRepairQueryParams,
    {}
  >({
    url: '/v1/quality/defect-repair-picture',
    method: 'get',
    ...variables,
    signal,
  });

export function defectRepairPictureV1ControllerGetByRepairQuery(
  variables: DefectRepairPictureV1ControllerGetByRepairVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DefectRepairPictureV1OutputDto>;
};

export function defectRepairPictureV1ControllerGetByRepairQuery(
  variables:
    | DefectRepairPictureV1ControllerGetByRepairVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DefectRepairPictureV1OutputDto>)
    | reactQuery.SkipToken;
};

export function defectRepairPictureV1ControllerGetByRepairQuery(
  variables:
    | DefectRepairPictureV1ControllerGetByRepairVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/defect-repair-picture',
      operationId: 'defectRepairPictureV1ControllerGetByRepair',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDefectRepairPictureV1ControllerGetByRepair(variables, signal),
  };
}

export const useSuspenseDefectRepairPictureV1ControllerGetByRepair = <
  TData = Schemas.DefectRepairPictureV1OutputDto,
>(
  variables: DefectRepairPictureV1ControllerGetByRepairVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectRepairPictureV1OutputDto,
      DefectRepairPictureV1ControllerGetByRepairError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DefectRepairPictureV1OutputDto,
    DefectRepairPictureV1ControllerGetByRepairError,
    TData
  >({
    ...defectRepairPictureV1ControllerGetByRepairQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDefectRepairPictureV1ControllerGetByRepair = <
  TData = Schemas.DefectRepairPictureV1OutputDto,
>(
  variables:
    | DefectRepairPictureV1ControllerGetByRepairVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectRepairPictureV1OutputDto,
      DefectRepairPictureV1ControllerGetByRepairError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.DefectRepairPictureV1OutputDto,
    DefectRepairPictureV1ControllerGetByRepairError,
    TData
  >({
    ...defectRepairPictureV1ControllerGetByRepairQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DefectReportPictureV1ControllerGetByDefectQueryParams = {
  defectId: string;
};

export type DefectReportPictureV1ControllerGetByDefectError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportPictureV1ControllerGetByDefectVariables = {
  queryParams: DefectReportPictureV1ControllerGetByDefectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportPictureV1ControllerGetByDefect = (
  variables: DefectReportPictureV1ControllerGetByDefectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectReportPictureV1OutputDto,
    DefectReportPictureV1ControllerGetByDefectError,
    undefined,
    {},
    DefectReportPictureV1ControllerGetByDefectQueryParams,
    {}
  >({
    url: '/v1/quality/defect-report-picture',
    method: 'get',
    ...variables,
    signal,
  });

export function defectReportPictureV1ControllerGetByDefectQuery(
  variables: DefectReportPictureV1ControllerGetByDefectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DefectReportPictureV1OutputDto>;
};

export function defectReportPictureV1ControllerGetByDefectQuery(
  variables:
    | DefectReportPictureV1ControllerGetByDefectVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DefectReportPictureV1OutputDto>)
    | reactQuery.SkipToken;
};

export function defectReportPictureV1ControllerGetByDefectQuery(
  variables:
    | DefectReportPictureV1ControllerGetByDefectVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/defect-report-picture',
      operationId: 'defectReportPictureV1ControllerGetByDefect',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDefectReportPictureV1ControllerGetByDefect(variables, signal),
  };
}

export const useSuspenseDefectReportPictureV1ControllerGetByDefect = <
  TData = Schemas.DefectReportPictureV1OutputDto,
>(
  variables: DefectReportPictureV1ControllerGetByDefectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportPictureV1OutputDto,
      DefectReportPictureV1ControllerGetByDefectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DefectReportPictureV1OutputDto,
    DefectReportPictureV1ControllerGetByDefectError,
    TData
  >({
    ...defectReportPictureV1ControllerGetByDefectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDefectReportPictureV1ControllerGetByDefect = <
  TData = Schemas.DefectReportPictureV1OutputDto,
>(
  variables:
    | DefectReportPictureV1ControllerGetByDefectVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportPictureV1OutputDto,
      DefectReportPictureV1ControllerGetByDefectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.DefectReportPictureV1OutputDto,
    DefectReportPictureV1ControllerGetByDefectError,
    TData
  >({
    ...defectReportPictureV1ControllerGetByDefectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DefectReportPictureV1ControllerGetListByRingsPathParams = {
  constructionSiteId: string;
};

export type DefectReportPictureV1ControllerGetListByRingsQueryParams = {
  ringNumberStart: number;
  ringNumberEnd: number;
  paginationPage: number;
  paginationSize: number;
};

export type DefectReportPictureV1ControllerGetListByRingsError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportPictureV1ControllerGetListByRingsVariables = {
  pathParams: DefectReportPictureV1ControllerGetListByRingsPathParams;
  queryParams: DefectReportPictureV1ControllerGetListByRingsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportPictureV1ControllerGetListByRings = (
  variables: DefectReportPictureV1ControllerGetListByRingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectReportPictureListV1OutputDto,
    DefectReportPictureV1ControllerGetListByRingsError,
    undefined,
    {},
    DefectReportPictureV1ControllerGetListByRingsQueryParams,
    DefectReportPictureV1ControllerGetListByRingsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/defect-report-pictures/by-rings',
    method: 'get',
    ...variables,
    signal,
  });

export function defectReportPictureV1ControllerGetListByRingsQuery(
  variables: DefectReportPictureV1ControllerGetListByRingsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DefectReportPictureListV1OutputDto>;
};

export function defectReportPictureV1ControllerGetListByRingsQuery(
  variables:
    | DefectReportPictureV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DefectReportPictureListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function defectReportPictureV1ControllerGetListByRingsQuery(
  variables:
    | DefectReportPictureV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/defect-report-pictures/by-rings',
      operationId: 'defectReportPictureV1ControllerGetListByRings',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDefectReportPictureV1ControllerGetListByRings(
              variables,
              signal,
            ),
  };
}

export const useSuspenseDefectReportPictureV1ControllerGetListByRings = <
  TData = Schemas.DefectReportPictureListV1OutputDto,
>(
  variables: DefectReportPictureV1ControllerGetListByRingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportPictureListV1OutputDto,
      DefectReportPictureV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DefectReportPictureListV1OutputDto,
    DefectReportPictureV1ControllerGetListByRingsError,
    TData
  >({
    ...defectReportPictureV1ControllerGetListByRingsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDefectReportPictureV1ControllerGetListByRings = <
  TData = Schemas.DefectReportPictureListV1OutputDto,
>(
  variables:
    | DefectReportPictureV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportPictureListV1OutputDto,
      DefectReportPictureV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.DefectReportPictureListV1OutputDto,
    DefectReportPictureV1ControllerGetListByRingsError,
    TData
  >({
    ...defectReportPictureV1ControllerGetListByRingsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DefectReportPictureV1ControllerUploadError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportPictureV1ControllerUploadVariables =
  ApiContext['fetcherOptions'];

export const fetchDefectReportPictureV1ControllerUpload = (
  variables: DefectReportPictureV1ControllerUploadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DefectReportPictureV1ControllerUploadError,
    undefined,
    {},
    {},
    {}
  >({
    url: '/v1/quality/defect-report-picture/upload',
    method: 'post',
    ...variables,
    signal,
  });

export const useDefectReportPictureV1ControllerUpload = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DefectReportPictureV1ControllerUploadError,
      DefectReportPictureV1ControllerUploadVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DefectReportPictureV1ControllerUploadError,
    DefectReportPictureV1ControllerUploadVariables
  >({
    mutationFn: (variables: DefectReportPictureV1ControllerUploadVariables) =>
      fetchDefectReportPictureV1ControllerUpload(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DefectReportPictureV1ControllerDeleteBatchError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportPictureV1ControllerDeleteBatchVariables = {
  body: Schemas.DefectReportPictureDeleteBatchV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportPictureV1ControllerDeleteBatch = (
  variables: DefectReportPictureV1ControllerDeleteBatchVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DefectReportPictureV1ControllerDeleteBatchError,
    Schemas.DefectReportPictureDeleteBatchV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/quality/defect-report-picture/delete-batch',
    method: 'post',
    ...variables,
    signal,
  });

export const useDefectReportPictureV1ControllerDeleteBatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DefectReportPictureV1ControllerDeleteBatchError,
      DefectReportPictureV1ControllerDeleteBatchVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DefectReportPictureV1ControllerDeleteBatchError,
    DefectReportPictureV1ControllerDeleteBatchVariables
  >({
    mutationFn: (
      variables: DefectReportPictureV1ControllerDeleteBatchVariables,
    ) =>
      fetchDefectReportPictureV1ControllerDeleteBatch(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DefectReportTypeV1ControllerGetListPathParams = {
  constructionSiteId: string;
};

export type DefectReportTypeV1ControllerGetListError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportTypeV1ControllerGetListVariables = {
  pathParams: DefectReportTypeV1ControllerGetListPathParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportTypeV1ControllerGetList = (
  variables: DefectReportTypeV1ControllerGetListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectReportTypeListV1OutputDto,
    DefectReportTypeV1ControllerGetListError,
    undefined,
    {},
    {},
    DefectReportTypeV1ControllerGetListPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/defect-report-types',
    method: 'get',
    ...variables,
    signal,
  });

export function defectReportTypeV1ControllerGetListQuery(
  variables: DefectReportTypeV1ControllerGetListVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DefectReportTypeListV1OutputDto>;
};

export function defectReportTypeV1ControllerGetListQuery(
  variables:
    | DefectReportTypeV1ControllerGetListVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DefectReportTypeListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function defectReportTypeV1ControllerGetListQuery(
  variables:
    | DefectReportTypeV1ControllerGetListVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/defect-report-types',
      operationId: 'defectReportTypeV1ControllerGetList',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDefectReportTypeV1ControllerGetList(variables, signal),
  };
}

export const useSuspenseDefectReportTypeV1ControllerGetList = <
  TData = Schemas.DefectReportTypeListV1OutputDto,
>(
  variables: DefectReportTypeV1ControllerGetListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportTypeListV1OutputDto,
      DefectReportTypeV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DefectReportTypeListV1OutputDto,
    DefectReportTypeV1ControllerGetListError,
    TData
  >({
    ...defectReportTypeV1ControllerGetListQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDefectReportTypeV1ControllerGetList = <
  TData = Schemas.DefectReportTypeListV1OutputDto,
>(
  variables:
    | DefectReportTypeV1ControllerGetListVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportTypeListV1OutputDto,
      DefectReportTypeV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.DefectReportTypeListV1OutputDto,
    DefectReportTypeV1ControllerGetListError,
    TData
  >({
    ...defectReportTypeV1ControllerGetListQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DefectReportV1ControllerGetListPathParams = {
  constructionSiteId: string;
};

export type DefectReportV1ControllerGetListQueryParams = {
  defectType?: string | null;
  toRepair?: boolean | null;
  indicator?: string | null;
  defectReportHistoryDate?: string | null;
  /**
   * @format date-time
   */
  defectReportDateStart?: string | null;
  /**
   * @format date-time
   */
  defectReportDateEnd?: string | null;
  status?: string[];
  defectRange?: string | null;
  ringNumberStart?: number | null;
  ringNumberEnd?: number | null;
  paginationPage?: number | null;
  paginationSize?: number | null;
  paginationSortField?: string | null;
  paginationSortDirection?: string | null;
};

export type DefectReportV1ControllerGetListError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportV1ControllerGetListVariables = {
  pathParams: DefectReportV1ControllerGetListPathParams;
  queryParams?: DefectReportV1ControllerGetListQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportV1ControllerGetList = (
  variables: DefectReportV1ControllerGetListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectReportViewV1OutputDto,
    DefectReportV1ControllerGetListError,
    undefined,
    {},
    DefectReportV1ControllerGetListQueryParams,
    DefectReportV1ControllerGetListPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/defect-reports',
    method: 'get',
    ...variables,
    signal,
  });

export function defectReportV1ControllerGetListQuery(
  variables: DefectReportV1ControllerGetListVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DefectReportViewV1OutputDto>;
};

export function defectReportV1ControllerGetListQuery(
  variables: DefectReportV1ControllerGetListVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DefectReportViewV1OutputDto>)
    | reactQuery.SkipToken;
};

export function defectReportV1ControllerGetListQuery(
  variables: DefectReportV1ControllerGetListVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/defect-reports',
      operationId: 'defectReportV1ControllerGetList',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDefectReportV1ControllerGetList(variables, signal),
  };
}

export const useSuspenseDefectReportV1ControllerGetList = <
  TData = Schemas.DefectReportViewV1OutputDto,
>(
  variables: DefectReportV1ControllerGetListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportViewV1OutputDto,
      DefectReportV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DefectReportViewV1OutputDto,
    DefectReportV1ControllerGetListError,
    TData
  >({
    ...defectReportV1ControllerGetListQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDefectReportV1ControllerGetList = <
  TData = Schemas.DefectReportViewV1OutputDto,
>(
  variables: DefectReportV1ControllerGetListVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportViewV1OutputDto,
      DefectReportV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.DefectReportViewV1OutputDto,
    DefectReportV1ControllerGetListError,
    TData
  >({
    ...defectReportV1ControllerGetListQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DefectReportV1ControllerUpdateDefectReportsPathParams = {
  constructionSiteId: string;
};

export type DefectReportV1ControllerUpdateDefectReportsError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportV1ControllerUpdateDefectReportsRequestBody =
  Schemas.DefectReportUpdateV1InputDto[];

export type DefectReportV1ControllerUpdateDefectReportsVariables = {
  body?: DefectReportV1ControllerUpdateDefectReportsRequestBody;
  pathParams: DefectReportV1ControllerUpdateDefectReportsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportV1ControllerUpdateDefectReports = (
  variables: DefectReportV1ControllerUpdateDefectReportsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectReportUpdateV1OutputDto,
    DefectReportV1ControllerUpdateDefectReportsError,
    DefectReportV1ControllerUpdateDefectReportsRequestBody,
    {},
    {},
    DefectReportV1ControllerUpdateDefectReportsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/defect-reports',
    method: 'put',
    ...variables,
    signal,
  });

export const useDefectReportV1ControllerUpdateDefectReports = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DefectReportUpdateV1OutputDto,
      DefectReportV1ControllerUpdateDefectReportsError,
      DefectReportV1ControllerUpdateDefectReportsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DefectReportUpdateV1OutputDto,
    DefectReportV1ControllerUpdateDefectReportsError,
    DefectReportV1ControllerUpdateDefectReportsVariables
  >({
    mutationFn: (
      variables: DefectReportV1ControllerUpdateDefectReportsVariables,
    ) =>
      fetchDefectReportV1ControllerUpdateDefectReports(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type DefectReportV1ControllerGetListByRingsPathParams = {
  constructionSiteId: string;
};

export type DefectReportV1ControllerGetListByRingsQueryParams = {
  ringNumberStart: number;
  ringNumberEnd: number;
  paginationPage?: number | null;
  paginationSize?: number | null;
};

export type DefectReportV1ControllerGetListByRingsError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportV1ControllerGetListByRingsVariables = {
  pathParams: DefectReportV1ControllerGetListByRingsPathParams;
  queryParams: DefectReportV1ControllerGetListByRingsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportV1ControllerGetListByRings = (
  variables: DefectReportV1ControllerGetListByRingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectReportListV1OutputDto,
    DefectReportV1ControllerGetListByRingsError,
    undefined,
    {},
    DefectReportV1ControllerGetListByRingsQueryParams,
    DefectReportV1ControllerGetListByRingsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/defect-reports/by-rings',
    method: 'get',
    ...variables,
    signal,
  });

export function defectReportV1ControllerGetListByRingsQuery(
  variables: DefectReportV1ControllerGetListByRingsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DefectReportListV1OutputDto>;
};

export function defectReportV1ControllerGetListByRingsQuery(
  variables:
    | DefectReportV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DefectReportListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function defectReportV1ControllerGetListByRingsQuery(
  variables:
    | DefectReportV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/defect-reports/by-rings',
      operationId: 'defectReportV1ControllerGetListByRings',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDefectReportV1ControllerGetListByRings(variables, signal),
  };
}

export const useSuspenseDefectReportV1ControllerGetListByRings = <
  TData = Schemas.DefectReportListV1OutputDto,
>(
  variables: DefectReportV1ControllerGetListByRingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportListV1OutputDto,
      DefectReportV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DefectReportListV1OutputDto,
    DefectReportV1ControllerGetListByRingsError,
    TData
  >({
    ...defectReportV1ControllerGetListByRingsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDefectReportV1ControllerGetListByRings = <
  TData = Schemas.DefectReportListV1OutputDto,
>(
  variables:
    | DefectReportV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectReportListV1OutputDto,
      DefectReportV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.DefectReportListV1OutputDto,
    DefectReportV1ControllerGetListByRingsError,
    TData
  >({
    ...defectReportV1ControllerGetListByRingsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type DefectReportV1ControllerExportPathParams = {
  constructionSiteId: string;
};

export type DefectReportV1ControllerExportError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportV1ControllerExportVariables = {
  body: Schemas.DefectReportExportV1InputDto;
  pathParams: DefectReportV1ControllerExportPathParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportV1ControllerExport = (
  variables: DefectReportV1ControllerExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    DefectReportV1ControllerExportError,
    Schemas.DefectReportExportV1InputDto,
    {},
    {},
    DefectReportV1ControllerExportPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/defect-reports/export',
    method: 'post',
    ...variables,
    signal,
  });

export const useDefectReportV1ControllerExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      DefectReportV1ControllerExportError,
      DefectReportV1ControllerExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    DefectReportV1ControllerExportError,
    DefectReportV1ControllerExportVariables
  >({
    mutationFn: (variables: DefectReportV1ControllerExportVariables) =>
      fetchDefectReportV1ControllerExport(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type DefectReportV1ControllerInvalidatePathParams = {
  id: string;
};

export type DefectReportV1ControllerInvalidateError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectReportV1ControllerInvalidateVariables = {
  pathParams: DefectReportV1ControllerInvalidatePathParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectReportV1ControllerInvalidate = (
  variables: DefectReportV1ControllerInvalidateVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectReportUpdateV1OutputDto,
    DefectReportV1ControllerInvalidateError,
    undefined,
    {},
    {},
    DefectReportV1ControllerInvalidatePathParams
  >({
    url: '/v1/quality/defect-reports/invalidate/{id}',
    method: 'put',
    ...variables,
    signal,
  });

export const useDefectReportV1ControllerInvalidate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DefectReportUpdateV1OutputDto,
      DefectReportV1ControllerInvalidateError,
      DefectReportV1ControllerInvalidateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DefectReportUpdateV1OutputDto,
    DefectReportV1ControllerInvalidateError,
    DefectReportV1ControllerInvalidateVariables
  >({
    mutationFn: (variables: DefectReportV1ControllerInvalidateVariables) =>
      fetchDefectReportV1ControllerInvalidate(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type IndicatorV1ControllerGetListPathParams = {
  constructionSiteId: string;
};

export type IndicatorV1ControllerGetListError = Fetcher.ErrorWrapper<undefined>;

export type IndicatorV1ControllerGetListVariables = {
  pathParams: IndicatorV1ControllerGetListPathParams;
} & ApiContext['fetcherOptions'];

export const fetchIndicatorV1ControllerGetList = (
  variables: IndicatorV1ControllerGetListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IndicatorListV1OutputDto,
    IndicatorV1ControllerGetListError,
    undefined,
    {},
    {},
    IndicatorV1ControllerGetListPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/indicators',
    method: 'get',
    ...variables,
    signal,
  });

export function indicatorV1ControllerGetListQuery(
  variables: IndicatorV1ControllerGetListVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.IndicatorListV1OutputDto>;
};

export function indicatorV1ControllerGetListQuery(
  variables: IndicatorV1ControllerGetListVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.IndicatorListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function indicatorV1ControllerGetListQuery(
  variables: IndicatorV1ControllerGetListVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/indicators',
      operationId: 'indicatorV1ControllerGetList',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchIndicatorV1ControllerGetList(variables, signal),
  };
}

export const useSuspenseIndicatorV1ControllerGetList = <
  TData = Schemas.IndicatorListV1OutputDto,
>(
  variables: IndicatorV1ControllerGetListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IndicatorListV1OutputDto,
      IndicatorV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.IndicatorListV1OutputDto,
    IndicatorV1ControllerGetListError,
    TData
  >({
    ...indicatorV1ControllerGetListQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useIndicatorV1ControllerGetList = <
  TData = Schemas.IndicatorListV1OutputDto,
>(
  variables: IndicatorV1ControllerGetListVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IndicatorListV1OutputDto,
      IndicatorV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.IndicatorListV1OutputDto,
    IndicatorV1ControllerGetListError,
    TData
  >({
    ...indicatorV1ControllerGetListQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RepairReportV1ControllerGetListByRingsPathParams = {
  constructionSiteId: string;
};

export type RepairReportV1ControllerGetListByRingsQueryParams = {
  ringNumberStart: number;
  ringNumberEnd: number;
  paginationPage?: number | null;
  paginationSize?: number | null;
};

export type RepairReportV1ControllerGetListByRingsError =
  Fetcher.ErrorWrapper<undefined>;

export type RepairReportV1ControllerGetListByRingsVariables = {
  pathParams: RepairReportV1ControllerGetListByRingsPathParams;
  queryParams: RepairReportV1ControllerGetListByRingsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRepairReportV1ControllerGetListByRings = (
  variables: RepairReportV1ControllerGetListByRingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RepairReportListV1OutputDto,
    RepairReportV1ControllerGetListByRingsError,
    undefined,
    {},
    RepairReportV1ControllerGetListByRingsQueryParams,
    RepairReportV1ControllerGetListByRingsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/repair-reports/by-rings',
    method: 'get',
    ...variables,
    signal,
  });

export function repairReportV1ControllerGetListByRingsQuery(
  variables: RepairReportV1ControllerGetListByRingsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.RepairReportListV1OutputDto>;
};

export function repairReportV1ControllerGetListByRingsQuery(
  variables:
    | RepairReportV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.RepairReportListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function repairReportV1ControllerGetListByRingsQuery(
  variables:
    | RepairReportV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/repair-reports/by-rings',
      operationId: 'repairReportV1ControllerGetListByRings',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRepairReportV1ControllerGetListByRings(variables, signal),
  };
}

export const useSuspenseRepairReportV1ControllerGetListByRings = <
  TData = Schemas.RepairReportListV1OutputDto,
>(
  variables: RepairReportV1ControllerGetListByRingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RepairReportListV1OutputDto,
      RepairReportV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RepairReportListV1OutputDto,
    RepairReportV1ControllerGetListByRingsError,
    TData
  >({
    ...repairReportV1ControllerGetListByRingsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRepairReportV1ControllerGetListByRings = <
  TData = Schemas.RepairReportListV1OutputDto,
>(
  variables:
    | RepairReportV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RepairReportListV1OutputDto,
      RepairReportV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RepairReportListV1OutputDto,
    RepairReportV1ControllerGetListByRingsError,
    TData
  >({
    ...repairReportV1ControllerGetListByRingsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RepairReportV1ControllerUploadRepairsPathParams = {
  constructionSiteId: string;
};

export type RepairReportV1ControllerUploadRepairsError =
  Fetcher.ErrorWrapper<undefined>;

export type RepairReportV1ControllerUploadRepairsVariables = {
  body: Schemas.RepairReportUploadV1InputDto;
  pathParams: RepairReportV1ControllerUploadRepairsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchRepairReportV1ControllerUploadRepairs = (
  variables: RepairReportV1ControllerUploadRepairsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RepairReportUploadV1OutputDto,
    RepairReportV1ControllerUploadRepairsError,
    Schemas.RepairReportUploadV1InputDto,
    {},
    {},
    RepairReportV1ControllerUploadRepairsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/repair-reports',
    method: 'post',
    ...variables,
    signal,
  });

export const useRepairReportV1ControllerUploadRepairs = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RepairReportUploadV1OutputDto,
      RepairReportV1ControllerUploadRepairsError,
      RepairReportV1ControllerUploadRepairsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.RepairReportUploadV1OutputDto,
    RepairReportV1ControllerUploadRepairsError,
    RepairReportV1ControllerUploadRepairsVariables
  >({
    mutationFn: (variables: RepairReportV1ControllerUploadRepairsVariables) =>
      fetchRepairReportV1ControllerUploadRepairs(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RepairReportV1ControllerInvalidatePathParams = {
  id: string;
};

export type RepairReportV1ControllerInvalidateError =
  Fetcher.ErrorWrapper<undefined>;

export type RepairReportV1ControllerInvalidateVariables = {
  pathParams: RepairReportV1ControllerInvalidatePathParams;
} & ApiContext['fetcherOptions'];

export const fetchRepairReportV1ControllerInvalidate = (
  variables: RepairReportV1ControllerInvalidateVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RepairReportUpdateV1OutputDto,
    RepairReportV1ControllerInvalidateError,
    undefined,
    {},
    {},
    RepairReportV1ControllerInvalidatePathParams
  >({
    url: '/v1/quality/repair-reports/invalidate/{id}',
    method: 'put',
    ...variables,
    signal,
  });

export const useRepairReportV1ControllerInvalidate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RepairReportUpdateV1OutputDto,
      RepairReportV1ControllerInvalidateError,
      RepairReportV1ControllerInvalidateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.RepairReportUpdateV1OutputDto,
    RepairReportV1ControllerInvalidateError,
    RepairReportV1ControllerInvalidateVariables
  >({
    mutationFn: (variables: RepairReportV1ControllerInvalidateVariables) =>
      fetchRepairReportV1ControllerInvalidate(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RepairReportPictureV1ControllerGetByRepairQueryParams = {
  repairId: string;
};

export type RepairReportPictureV1ControllerGetByRepairError =
  Fetcher.ErrorWrapper<undefined>;

export type RepairReportPictureV1ControllerGetByRepairVariables = {
  queryParams: RepairReportPictureV1ControllerGetByRepairQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRepairReportPictureV1ControllerGetByRepair = (
  variables: RepairReportPictureV1ControllerGetByRepairVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RepairReportPictureV1OutputDto,
    RepairReportPictureV1ControllerGetByRepairError,
    undefined,
    {},
    RepairReportPictureV1ControllerGetByRepairQueryParams,
    {}
  >({
    url: '/v1/quality/repair-report-picture',
    method: 'get',
    ...variables,
    signal,
  });

export function repairReportPictureV1ControllerGetByRepairQuery(
  variables: RepairReportPictureV1ControllerGetByRepairVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.RepairReportPictureV1OutputDto>;
};

export function repairReportPictureV1ControllerGetByRepairQuery(
  variables:
    | RepairReportPictureV1ControllerGetByRepairVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.RepairReportPictureV1OutputDto>)
    | reactQuery.SkipToken;
};

export function repairReportPictureV1ControllerGetByRepairQuery(
  variables:
    | RepairReportPictureV1ControllerGetByRepairVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/repair-report-picture',
      operationId: 'repairReportPictureV1ControllerGetByRepair',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRepairReportPictureV1ControllerGetByRepair(variables, signal),
  };
}

export const useSuspenseRepairReportPictureV1ControllerGetByRepair = <
  TData = Schemas.RepairReportPictureV1OutputDto,
>(
  variables: RepairReportPictureV1ControllerGetByRepairVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RepairReportPictureV1OutputDto,
      RepairReportPictureV1ControllerGetByRepairError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RepairReportPictureV1OutputDto,
    RepairReportPictureV1ControllerGetByRepairError,
    TData
  >({
    ...repairReportPictureV1ControllerGetByRepairQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRepairReportPictureV1ControllerGetByRepair = <
  TData = Schemas.RepairReportPictureV1OutputDto,
>(
  variables:
    | RepairReportPictureV1ControllerGetByRepairVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RepairReportPictureV1OutputDto,
      RepairReportPictureV1ControllerGetByRepairError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RepairReportPictureV1OutputDto,
    RepairReportPictureV1ControllerGetByRepairError,
    TData
  >({
    ...repairReportPictureV1ControllerGetByRepairQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RepairReportPictureV1ControllerGetListByRingsPathParams = {
  constructionSiteId: string;
};

export type RepairReportPictureV1ControllerGetListByRingsQueryParams = {
  ringNumberStart: number;
  ringNumberEnd: number;
  paginationPage: number;
  paginationSize: number;
};

export type RepairReportPictureV1ControllerGetListByRingsError =
  Fetcher.ErrorWrapper<undefined>;

export type RepairReportPictureV1ControllerGetListByRingsVariables = {
  pathParams: RepairReportPictureV1ControllerGetListByRingsPathParams;
  queryParams: RepairReportPictureV1ControllerGetListByRingsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRepairReportPictureV1ControllerGetListByRings = (
  variables: RepairReportPictureV1ControllerGetListByRingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RepairReportPictureListV1OutputDto,
    RepairReportPictureV1ControllerGetListByRingsError,
    undefined,
    {},
    RepairReportPictureV1ControllerGetListByRingsQueryParams,
    RepairReportPictureV1ControllerGetListByRingsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/repair-report-pictures/by-rings',
    method: 'get',
    ...variables,
    signal,
  });

export function repairReportPictureV1ControllerGetListByRingsQuery(
  variables: RepairReportPictureV1ControllerGetListByRingsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.RepairReportPictureListV1OutputDto>;
};

export function repairReportPictureV1ControllerGetListByRingsQuery(
  variables:
    | RepairReportPictureV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.RepairReportPictureListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function repairReportPictureV1ControllerGetListByRingsQuery(
  variables:
    | RepairReportPictureV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/repair-report-pictures/by-rings',
      operationId: 'repairReportPictureV1ControllerGetListByRings',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRepairReportPictureV1ControllerGetListByRings(
              variables,
              signal,
            ),
  };
}

export const useSuspenseRepairReportPictureV1ControllerGetListByRings = <
  TData = Schemas.RepairReportPictureListV1OutputDto,
>(
  variables: RepairReportPictureV1ControllerGetListByRingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RepairReportPictureListV1OutputDto,
      RepairReportPictureV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RepairReportPictureListV1OutputDto,
    RepairReportPictureV1ControllerGetListByRingsError,
    TData
  >({
    ...repairReportPictureV1ControllerGetListByRingsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRepairReportPictureV1ControllerGetListByRings = <
  TData = Schemas.RepairReportPictureListV1OutputDto,
>(
  variables:
    | RepairReportPictureV1ControllerGetListByRingsVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RepairReportPictureListV1OutputDto,
      RepairReportPictureV1ControllerGetListByRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RepairReportPictureListV1OutputDto,
    RepairReportPictureV1ControllerGetListByRingsError,
    TData
  >({
    ...repairReportPictureV1ControllerGetListByRingsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RepairReportPictureV1ControllerUploadError =
  Fetcher.ErrorWrapper<undefined>;

export type RepairReportPictureV1ControllerUploadVariables =
  ApiContext['fetcherOptions'];

export const fetchRepairReportPictureV1ControllerUpload = (
  variables: RepairReportPictureV1ControllerUploadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    RepairReportPictureV1ControllerUploadError,
    undefined,
    {},
    {},
    {}
  >({
    url: '/v1/quality/repair-report-picture/upload',
    method: 'post',
    ...variables,
    signal,
  });

export const useRepairReportPictureV1ControllerUpload = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RepairReportPictureV1ControllerUploadError,
      RepairReportPictureV1ControllerUploadVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    RepairReportPictureV1ControllerUploadError,
    RepairReportPictureV1ControllerUploadVariables
  >({
    mutationFn: (variables: RepairReportPictureV1ControllerUploadVariables) =>
      fetchRepairReportPictureV1ControllerUpload(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RepairReportPictureV1ControllerDeleteBatchError =
  Fetcher.ErrorWrapper<undefined>;

export type RepairReportPictureV1ControllerDeleteBatchVariables = {
  body: Schemas.RepairReportPictureDeleteBatchV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchRepairReportPictureV1ControllerDeleteBatch = (
  variables: RepairReportPictureV1ControllerDeleteBatchVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    RepairReportPictureV1ControllerDeleteBatchError,
    Schemas.RepairReportPictureDeleteBatchV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/quality/repair-report-picture/delete-batch',
    method: 'post',
    ...variables,
    signal,
  });

export const useRepairReportPictureV1ControllerDeleteBatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RepairReportPictureV1ControllerDeleteBatchError,
      RepairReportPictureV1ControllerDeleteBatchVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    RepairReportPictureV1ControllerDeleteBatchError,
    RepairReportPictureV1ControllerDeleteBatchVariables
  >({
    mutationFn: (
      variables: RepairReportPictureV1ControllerDeleteBatchVariables,
    ) =>
      fetchRepairReportPictureV1ControllerDeleteBatch(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RingV1ControllerGetRingsPathParams = {
  constructionSiteId: string;
};

export type RingV1ControllerGetRingsError = Fetcher.ErrorWrapper<undefined>;

export type RingV1ControllerGetRingsVariables = {
  pathParams: RingV1ControllerGetRingsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchRingV1ControllerGetRings = (
  variables: RingV1ControllerGetRingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RingListV1OutputDto,
    RingV1ControllerGetRingsError,
    undefined,
    {},
    {},
    RingV1ControllerGetRingsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings',
    method: 'get',
    ...variables,
    signal,
  });

export function ringV1ControllerGetRingsQuery(
  variables: RingV1ControllerGetRingsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.RingListV1OutputDto>;
};

export function ringV1ControllerGetRingsQuery(
  variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.RingListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function ringV1ControllerGetRingsQuery(
  variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/rings',
      operationId: 'ringV1ControllerGetRings',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRingV1ControllerGetRings(variables, signal),
  };
}

export const useSuspenseRingV1ControllerGetRings = <
  TData = Schemas.RingListV1OutputDto,
>(
  variables: RingV1ControllerGetRingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingListV1OutputDto,
      RingV1ControllerGetRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RingListV1OutputDto,
    RingV1ControllerGetRingsError,
    TData
  >({
    ...ringV1ControllerGetRingsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useRingV1ControllerGetRings = <
  TData = Schemas.RingListV1OutputDto,
>(
  variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingListV1OutputDto,
      RingV1ControllerGetRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RingListV1OutputDto,
    RingV1ControllerGetRingsError,
    TData
  >({
    ...ringV1ControllerGetRingsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingV1ControllerGetRingsDetailsPathParams = {
  constructionSiteId: string;
};

export type RingV1ControllerGetRingsDetailsQueryParams = {
  startRing: number;
  endRing: number;
};

export type RingV1ControllerGetRingsDetailsError =
  Fetcher.ErrorWrapper<undefined>;

export type RingV1ControllerGetRingsDetailsVariables = {
  pathParams: RingV1ControllerGetRingsDetailsPathParams;
  queryParams: RingV1ControllerGetRingsDetailsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRingV1ControllerGetRingsDetails = (
  variables: RingV1ControllerGetRingsDetailsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RingDetailsListV1OutputDto,
    RingV1ControllerGetRingsDetailsError,
    undefined,
    {},
    RingV1ControllerGetRingsDetailsQueryParams,
    RingV1ControllerGetRingsDetailsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-segments',
    method: 'get',
    ...variables,
    signal,
  });

export function ringV1ControllerGetRingsDetailsQuery(
  variables: RingV1ControllerGetRingsDetailsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.RingDetailsListV1OutputDto>;
};

export function ringV1ControllerGetRingsDetailsQuery(
  variables: RingV1ControllerGetRingsDetailsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.RingDetailsListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function ringV1ControllerGetRingsDetailsQuery(
  variables: RingV1ControllerGetRingsDetailsVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/rings-segments',
      operationId: 'ringV1ControllerGetRingsDetails',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRingV1ControllerGetRingsDetails(variables, signal),
  };
}

export const useSuspenseRingV1ControllerGetRingsDetails = <
  TData = Schemas.RingDetailsListV1OutputDto,
>(
  variables: RingV1ControllerGetRingsDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingDetailsListV1OutputDto,
      RingV1ControllerGetRingsDetailsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RingDetailsListV1OutputDto,
    RingV1ControllerGetRingsDetailsError,
    TData
  >({
    ...ringV1ControllerGetRingsDetailsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRingV1ControllerGetRingsDetails = <
  TData = Schemas.RingDetailsListV1OutputDto,
>(
  variables: RingV1ControllerGetRingsDetailsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingDetailsListV1OutputDto,
      RingV1ControllerGetRingsDetailsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RingDetailsListV1OutputDto,
    RingV1ControllerGetRingsDetailsError,
    TData
  >({
    ...ringV1ControllerGetRingsDetailsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingValidationV1ControllerGetListPathParams = {
  constructionSiteId: string;
};

export type RingValidationV1ControllerGetListQueryParams = {
  ringNumberStart?: number | null;
  ringNumberEnd?: number | null;
  status?: string[];
  complianceDateStart?: string | null;
  complianceDateEnd?: string | null;
  approvalDateStart?: string | null;
  approvalDateEnd?: string | null;
  paginationPage?: number | null;
  paginationSize?: number | null;
  paginationSortField?: string | null;
  paginationSortDirection?: string | null;
};

export type RingValidationV1ControllerGetListError =
  Fetcher.ErrorWrapper<undefined>;

export type RingValidationV1ControllerGetListVariables = {
  pathParams: RingValidationV1ControllerGetListPathParams;
  queryParams?: RingValidationV1ControllerGetListQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRingValidationV1ControllerGetList = (
  variables: RingValidationV1ControllerGetListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RingValidationListV1OutputDto,
    RingValidationV1ControllerGetListError,
    undefined,
    {},
    RingValidationV1ControllerGetListQueryParams,
    RingValidationV1ControllerGetListPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-validation',
    method: 'get',
    ...variables,
    signal,
  });

export function ringValidationV1ControllerGetListQuery(
  variables: RingValidationV1ControllerGetListVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.RingValidationListV1OutputDto>;
};

export function ringValidationV1ControllerGetListQuery(
  variables: RingValidationV1ControllerGetListVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.RingValidationListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function ringValidationV1ControllerGetListQuery(
  variables: RingValidationV1ControllerGetListVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/rings-validation',
      operationId: 'ringValidationV1ControllerGetList',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRingValidationV1ControllerGetList(variables, signal),
  };
}

export const useSuspenseRingValidationV1ControllerGetList = <
  TData = Schemas.RingValidationListV1OutputDto,
>(
  variables: RingValidationV1ControllerGetListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingValidationListV1OutputDto,
      RingValidationV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RingValidationListV1OutputDto,
    RingValidationV1ControllerGetListError,
    TData
  >({
    ...ringValidationV1ControllerGetListQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRingValidationV1ControllerGetList = <
  TData = Schemas.RingValidationListV1OutputDto,
>(
  variables: RingValidationV1ControllerGetListVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingValidationListV1OutputDto,
      RingValidationV1ControllerGetListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RingValidationListV1OutputDto,
    RingValidationV1ControllerGetListError,
    TData
  >({
    ...ringValidationV1ControllerGetListQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingValidationV1ControllerUploadRingCompliancePathParams = {
  constructionSiteId: string;
};

export type RingValidationV1ControllerUploadRingComplianceError =
  Fetcher.ErrorWrapper<undefined>;

export type RingValidationV1ControllerUploadRingComplianceVariables = {
  body: Schemas.RingUploadV1InputDto;
  pathParams: RingValidationV1ControllerUploadRingCompliancePathParams;
} & ApiContext['fetcherOptions'];

export const fetchRingValidationV1ControllerUploadRingCompliance = (
  variables: RingValidationV1ControllerUploadRingComplianceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RingUploadV1OutputDto,
    RingValidationV1ControllerUploadRingComplianceError,
    Schemas.RingUploadV1InputDto,
    {},
    {},
    RingValidationV1ControllerUploadRingCompliancePathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-validation',
    method: 'post',
    ...variables,
    signal,
  });

export const useRingValidationV1ControllerUploadRingCompliance = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RingUploadV1OutputDto,
      RingValidationV1ControllerUploadRingComplianceError,
      RingValidationV1ControllerUploadRingComplianceVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.RingUploadV1OutputDto,
    RingValidationV1ControllerUploadRingComplianceError,
    RingValidationV1ControllerUploadRingComplianceVariables
  >({
    mutationFn: (
      variables: RingValidationV1ControllerUploadRingComplianceVariables,
    ) =>
      fetchRingValidationV1ControllerUploadRingCompliance(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RingValidationV1ControllerGetDetailPathParams = {
  constructionSiteId: string;
  ringId: string;
};

export type RingValidationV1ControllerGetDetailError =
  Fetcher.ErrorWrapper<undefined>;

export type RingValidationV1ControllerGetDetailVariables = {
  pathParams: RingValidationV1ControllerGetDetailPathParams;
} & ApiContext['fetcherOptions'];

export const fetchRingValidationV1ControllerGetDetail = (
  variables: RingValidationV1ControllerGetDetailVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RingValidationDetailV1OutputDto,
    RingValidationV1ControllerGetDetailError,
    undefined,
    {},
    {},
    RingValidationV1ControllerGetDetailPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-validation/{ringId}',
    method: 'get',
    ...variables,
    signal,
  });

export function ringValidationV1ControllerGetDetailQuery(
  variables: RingValidationV1ControllerGetDetailVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.RingValidationDetailV1OutputDto>;
};

export function ringValidationV1ControllerGetDetailQuery(
  variables:
    | RingValidationV1ControllerGetDetailVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.RingValidationDetailV1OutputDto>)
    | reactQuery.SkipToken;
};

export function ringValidationV1ControllerGetDetailQuery(
  variables:
    | RingValidationV1ControllerGetDetailVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/rings-validation/{ringId}',
      operationId: 'ringValidationV1ControllerGetDetail',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRingValidationV1ControllerGetDetail(variables, signal),
  };
}

export const useSuspenseRingValidationV1ControllerGetDetail = <
  TData = Schemas.RingValidationDetailV1OutputDto,
>(
  variables: RingValidationV1ControllerGetDetailVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingValidationDetailV1OutputDto,
      RingValidationV1ControllerGetDetailError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RingValidationDetailV1OutputDto,
    RingValidationV1ControllerGetDetailError,
    TData
  >({
    ...ringValidationV1ControllerGetDetailQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRingValidationV1ControllerGetDetail = <
  TData = Schemas.RingValidationDetailV1OutputDto,
>(
  variables:
    | RingValidationV1ControllerGetDetailVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingValidationDetailV1OutputDto,
      RingValidationV1ControllerGetDetailError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RingValidationDetailV1OutputDto,
    RingValidationV1ControllerGetDetailError,
    TData
  >({
    ...ringValidationV1ControllerGetDetailQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingValidationV1ControllerGetPicturesPathParams = {
  constructionSiteId: string;
  ringId: string;
};

export type RingValidationV1ControllerGetPicturesQueryParams = {
  paginationPage?: number | null;
  paginationSize?: number | null;
};

export type RingValidationV1ControllerGetPicturesError =
  Fetcher.ErrorWrapper<undefined>;

export type RingValidationV1ControllerGetPicturesVariables = {
  pathParams: RingValidationV1ControllerGetPicturesPathParams;
  queryParams?: RingValidationV1ControllerGetPicturesQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRingValidationV1ControllerGetPictures = (
  variables: RingValidationV1ControllerGetPicturesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RingPicturesV1OutputDto,
    RingValidationV1ControllerGetPicturesError,
    undefined,
    {},
    RingValidationV1ControllerGetPicturesQueryParams,
    RingValidationV1ControllerGetPicturesPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-validation/{ringId}/pictures',
    method: 'get',
    ...variables,
    signal,
  });

export function ringValidationV1ControllerGetPicturesQuery(
  variables: RingValidationV1ControllerGetPicturesVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.RingPicturesV1OutputDto>;
};

export function ringValidationV1ControllerGetPicturesQuery(
  variables:
    | RingValidationV1ControllerGetPicturesVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.RingPicturesV1OutputDto>)
    | reactQuery.SkipToken;
};

export function ringValidationV1ControllerGetPicturesQuery(
  variables:
    | RingValidationV1ControllerGetPicturesVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/rings-validation/{ringId}/pictures',
      operationId: 'ringValidationV1ControllerGetPictures',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRingValidationV1ControllerGetPictures(variables, signal),
  };
}

export const useSuspenseRingValidationV1ControllerGetPictures = <
  TData = Schemas.RingPicturesV1OutputDto,
>(
  variables: RingValidationV1ControllerGetPicturesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingPicturesV1OutputDto,
      RingValidationV1ControllerGetPicturesError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RingPicturesV1OutputDto,
    RingValidationV1ControllerGetPicturesError,
    TData
  >({
    ...ringValidationV1ControllerGetPicturesQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useRingValidationV1ControllerGetPictures = <
  TData = Schemas.RingPicturesV1OutputDto,
>(
  variables:
    | RingValidationV1ControllerGetPicturesVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingPicturesV1OutputDto,
      RingValidationV1ControllerGetPicturesError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RingPicturesV1OutputDto,
    RingValidationV1ControllerGetPicturesError,
    TData
  >({
    ...ringValidationV1ControllerGetPicturesQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingValidationV1ControllerExportPdfsPathParams = {
  constructionSiteId: string;
};

export type RingValidationV1ControllerExportPdfsError =
  Fetcher.ErrorWrapper<undefined>;

export type RingValidationV1ControllerExportPdfsVariables = {
  body: Schemas.ExportRingValidationPdfsV1InputDto;
  pathParams: RingValidationV1ControllerExportPdfsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchRingValidationV1ControllerExportPdfs = (
  variables: RingValidationV1ControllerExportPdfsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ExportRingValidationPdfsV1OutputDto,
    RingValidationV1ControllerExportPdfsError,
    Schemas.ExportRingValidationPdfsV1InputDto,
    {},
    {},
    RingValidationV1ControllerExportPdfsPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-validation/export-pdfs',
    method: 'post',
    ...variables,
    signal,
  });

export const useRingValidationV1ControllerExportPdfs = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ExportRingValidationPdfsV1OutputDto,
      RingValidationV1ControllerExportPdfsError,
      RingValidationV1ControllerExportPdfsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ExportRingValidationPdfsV1OutputDto,
    RingValidationV1ControllerExportPdfsError,
    RingValidationV1ControllerExportPdfsVariables
  >({
    mutationFn: (variables: RingValidationV1ControllerExportPdfsVariables) =>
      fetchRingValidationV1ControllerExportPdfs(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RingValidationV1ControllerValidatePathParams = {
  constructionSiteId: string;
};

export type RingValidationV1ControllerValidateError =
  Fetcher.ErrorWrapper<undefined>;

export type RingValidationV1ControllerValidateVariables = {
  body: Schemas.ValidateRingsV1InputDto;
  pathParams: RingValidationV1ControllerValidatePathParams;
} & ApiContext['fetcherOptions'];

export const fetchRingValidationV1ControllerValidate = (
  variables: RingValidationV1ControllerValidateVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ValidateRingsV1OutputDto,
    RingValidationV1ControllerValidateError,
    Schemas.ValidateRingsV1InputDto,
    {},
    {},
    RingValidationV1ControllerValidatePathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-validation/validate',
    method: 'post',
    ...variables,
    signal,
  });

export const useRingValidationV1ControllerValidate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ValidateRingsV1OutputDto,
      RingValidationV1ControllerValidateError,
      RingValidationV1ControllerValidateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ValidateRingsV1OutputDto,
    RingValidationV1ControllerValidateError,
    RingValidationV1ControllerValidateVariables
  >({
    mutationFn: (variables: RingValidationV1ControllerValidateVariables) =>
      fetchRingValidationV1ControllerValidate(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type RingValidationV1ControllerInvalidateRingPathParams = {
  constructionSiteId: string;
  ringId: string;
};

export type RingValidationV1ControllerInvalidateRingError =
  Fetcher.ErrorWrapper<undefined>;

export type RingValidationV1ControllerInvalidateRingVariables = {
  body: Schemas.InvalidateRingV1InputDto;
  pathParams: RingValidationV1ControllerInvalidateRingPathParams;
} & ApiContext['fetcherOptions'];

export const fetchRingValidationV1ControllerInvalidateRing = (
  variables: RingValidationV1ControllerInvalidateRingVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.InvalidateRingV1OutputDto,
    RingValidationV1ControllerInvalidateRingError,
    Schemas.InvalidateRingV1InputDto,
    {},
    {},
    RingValidationV1ControllerInvalidateRingPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/rings-validation/{ringId}/invalidate',
    method: 'post',
    ...variables,
    signal,
  });

export const useRingValidationV1ControllerInvalidateRing = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.InvalidateRingV1OutputDto,
      RingValidationV1ControllerInvalidateRingError,
      RingValidationV1ControllerInvalidateRingVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.InvalidateRingV1OutputDto,
    RingValidationV1ControllerInvalidateRingError,
    RingValidationV1ControllerInvalidateRingVariables
  >({
    mutationFn: (
      variables: RingValidationV1ControllerInvalidateRingVariables,
    ) =>
      fetchRingValidationV1ControllerInvalidateRing(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentRefusalPictureV1ControllerGetByRefusalQueryParams = {
  refusalId: string;
};

export type SegmentRefusalPictureV1ControllerGetByRefusalError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentRefusalPictureV1ControllerGetByRefusalVariables = {
  queryParams: SegmentRefusalPictureV1ControllerGetByRefusalQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentRefusalPictureV1ControllerGetByRefusal = (
  variables: SegmentRefusalPictureV1ControllerGetByRefusalVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentRefusalPictureV1OutputDto,
    SegmentRefusalPictureV1ControllerGetByRefusalError,
    undefined,
    {},
    SegmentRefusalPictureV1ControllerGetByRefusalQueryParams,
    {}
  >({
    url: '/v1/quality/segment-refusal-picture',
    method: 'get',
    ...variables,
    signal,
  });

export function segmentRefusalPictureV1ControllerGetByRefusalQuery(
  variables: SegmentRefusalPictureV1ControllerGetByRefusalVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.SegmentRefusalPictureV1OutputDto>;
};

export function segmentRefusalPictureV1ControllerGetByRefusalQuery(
  variables:
    | SegmentRefusalPictureV1ControllerGetByRefusalVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.SegmentRefusalPictureV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentRefusalPictureV1ControllerGetByRefusalQuery(
  variables:
    | SegmentRefusalPictureV1ControllerGetByRefusalVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/segment-refusal-picture',
      operationId: 'segmentRefusalPictureV1ControllerGetByRefusal',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentRefusalPictureV1ControllerGetByRefusal(
              variables,
              signal,
            ),
  };
}

export const useSuspenseSegmentRefusalPictureV1ControllerGetByRefusal = <
  TData = Schemas.SegmentRefusalPictureV1OutputDto,
>(
  variables: SegmentRefusalPictureV1ControllerGetByRefusalVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentRefusalPictureV1OutputDto,
      SegmentRefusalPictureV1ControllerGetByRefusalError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentRefusalPictureV1OutputDto,
    SegmentRefusalPictureV1ControllerGetByRefusalError,
    TData
  >({
    ...segmentRefusalPictureV1ControllerGetByRefusalQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentRefusalPictureV1ControllerGetByRefusal = <
  TData = Schemas.SegmentRefusalPictureV1OutputDto,
>(
  variables:
    | SegmentRefusalPictureV1ControllerGetByRefusalVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentRefusalPictureV1OutputDto,
      SegmentRefusalPictureV1ControllerGetByRefusalError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentRefusalPictureV1OutputDto,
    SegmentRefusalPictureV1ControllerGetByRefusalError,
    TData
  >({
    ...segmentRefusalPictureV1ControllerGetByRefusalQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentV1ControllerUpdateDetailsPathParams = {
  id: string;
};

export type SegmentV1ControllerUpdateDetailsError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerUpdateDetailsVariables = {
  body: Schemas.SegmentV1UpdateInputDto;
  pathParams: SegmentV1ControllerUpdateDetailsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerUpdateDetails = (
  variables: SegmentV1ControllerUpdateDetailsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentV1UpdateOutputDto,
    SegmentV1ControllerUpdateDetailsError,
    Schemas.SegmentV1UpdateInputDto,
    {},
    {},
    SegmentV1ControllerUpdateDetailsPathParams
  >({ url: '/v1/quality/segment/{id}', method: 'put', ...variables, signal });

export const useSegmentV1ControllerUpdateDetails = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SegmentV1UpdateOutputDto,
      SegmentV1ControllerUpdateDetailsError,
      SegmentV1ControllerUpdateDetailsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SegmentV1UpdateOutputDto,
    SegmentV1ControllerUpdateDetailsError,
    SegmentV1ControllerUpdateDetailsVariables
  >({
    mutationFn: (variables: SegmentV1ControllerUpdateDetailsVariables) =>
      fetchSegmentV1ControllerUpdateDetails(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentV1ControllerDeleteSegmentPathParams = {
  id: string;
};

export type SegmentV1ControllerDeleteSegmentError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerDeleteSegmentVariables = {
  pathParams: SegmentV1ControllerDeleteSegmentPathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerDeleteSegment = (
  variables: SegmentV1ControllerDeleteSegmentVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentV1DeleteOutputDto,
    SegmentV1ControllerDeleteSegmentError,
    undefined,
    {},
    {},
    SegmentV1ControllerDeleteSegmentPathParams
  >({
    url: '/v1/quality/segment/{id}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useSegmentV1ControllerDeleteSegment = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SegmentV1DeleteOutputDto,
      SegmentV1ControllerDeleteSegmentError,
      SegmentV1ControllerDeleteSegmentVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SegmentV1DeleteOutputDto,
    SegmentV1ControllerDeleteSegmentError,
    SegmentV1ControllerDeleteSegmentVariables
  >({
    mutationFn: (variables: SegmentV1ControllerDeleteSegmentVariables) =>
      fetchSegmentV1ControllerDeleteSegment(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentV1ControllerGetSegmentsByConstructionSitePathParams = {
  constructionSiteId: string;
};

export type SegmentV1ControllerGetSegmentsByConstructionSiteError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerGetSegmentsByConstructionSiteVariables = {
  pathParams: SegmentV1ControllerGetSegmentsByConstructionSitePathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerGetSegmentsByConstructionSite = (
  variables: SegmentV1ControllerGetSegmentsByConstructionSiteVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentListV1OutputDto,
    SegmentV1ControllerGetSegmentsByConstructionSiteError,
    undefined,
    {},
    {},
    SegmentV1ControllerGetSegmentsByConstructionSitePathParams
  >({
    url: '/v1/quality/{constructionSiteId}/segments',
    method: 'get',
    ...variables,
    signal,
  });

export function segmentV1ControllerGetSegmentsByConstructionSiteQuery(
  variables: SegmentV1ControllerGetSegmentsByConstructionSiteVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SegmentListV1OutputDto>;
};

export function segmentV1ControllerGetSegmentsByConstructionSiteQuery(
  variables:
    | SegmentV1ControllerGetSegmentsByConstructionSiteVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.SegmentListV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentV1ControllerGetSegmentsByConstructionSiteQuery(
  variables:
    | SegmentV1ControllerGetSegmentsByConstructionSiteVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/segments',
      operationId: 'segmentV1ControllerGetSegmentsByConstructionSite',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentV1ControllerGetSegmentsByConstructionSite(
              variables,
              signal,
            ),
  };
}

export const useSuspenseSegmentV1ControllerGetSegmentsByConstructionSite = <
  TData = Schemas.SegmentListV1OutputDto,
>(
  variables: SegmentV1ControllerGetSegmentsByConstructionSiteVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentListV1OutputDto,
      SegmentV1ControllerGetSegmentsByConstructionSiteError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentListV1OutputDto,
    SegmentV1ControllerGetSegmentsByConstructionSiteError,
    TData
  >({
    ...segmentV1ControllerGetSegmentsByConstructionSiteQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentV1ControllerGetSegmentsByConstructionSite = <
  TData = Schemas.SegmentListV1OutputDto,
>(
  variables:
    | SegmentV1ControllerGetSegmentsByConstructionSiteVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentListV1OutputDto,
      SegmentV1ControllerGetSegmentsByConstructionSiteError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentListV1OutputDto,
    SegmentV1ControllerGetSegmentsByConstructionSiteError,
    TData
  >({
    ...segmentV1ControllerGetSegmentsByConstructionSiteQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type TunnelPositionV1ControllerGetPathParams = {
  constructionSiteId: string;
};

export type TunnelPositionV1ControllerGetError =
  Fetcher.ErrorWrapper<undefined>;

export type TunnelPositionV1ControllerGetVariables = {
  pathParams: TunnelPositionV1ControllerGetPathParams;
} & ApiContext['fetcherOptions'];

export const fetchTunnelPositionV1ControllerGet = (
  variables: TunnelPositionV1ControllerGetVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TunnelPositionV1OutputDto,
    TunnelPositionV1ControllerGetError,
    undefined,
    {},
    {},
    TunnelPositionV1ControllerGetPathParams
  >({
    url: '/v1/quality/{constructionSiteId}/tunnel-position',
    method: 'get',
    ...variables,
    signal,
  });

export function tunnelPositionV1ControllerGetQuery(
  variables: TunnelPositionV1ControllerGetVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.TunnelPositionV1OutputDto>;
};

export function tunnelPositionV1ControllerGetQuery(
  variables: TunnelPositionV1ControllerGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.TunnelPositionV1OutputDto>)
    | reactQuery.SkipToken;
};

export function tunnelPositionV1ControllerGetQuery(
  variables: TunnelPositionV1ControllerGetVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/quality/{constructionSiteId}/tunnel-position',
      operationId: 'tunnelPositionV1ControllerGet',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchTunnelPositionV1ControllerGet(variables, signal),
  };
}

export const useSuspenseTunnelPositionV1ControllerGet = <
  TData = Schemas.TunnelPositionV1OutputDto,
>(
  variables: TunnelPositionV1ControllerGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TunnelPositionV1OutputDto,
      TunnelPositionV1ControllerGetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.TunnelPositionV1OutputDto,
    TunnelPositionV1ControllerGetError,
    TData
  >({
    ...tunnelPositionV1ControllerGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useTunnelPositionV1ControllerGet = <
  TData = Schemas.TunnelPositionV1OutputDto,
>(
  variables: TunnelPositionV1ControllerGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TunnelPositionV1OutputDto,
      TunnelPositionV1ControllerGetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.TunnelPositionV1OutputDto,
    TunnelPositionV1ControllerGetError,
    TData
  >({
    ...tunnelPositionV1ControllerGetQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ReportControllerV1GetTopLevelCriticalTaskAggregateQueryParams = {
  constructionSiteId: string;
  startDate: string;
  endDate: string;
  reportId?: string;
};

export type ReportControllerV1GetTopLevelCriticalTaskAggregateError =
  Fetcher.ErrorWrapper<undefined>;

export type ReportControllerV1GetTopLevelCriticalTaskAggregateVariables = {
  queryParams: ReportControllerV1GetTopLevelCriticalTaskAggregateQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchReportControllerV1GetTopLevelCriticalTaskAggregate = (
  variables: ReportControllerV1GetTopLevelCriticalTaskAggregateVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetTopLevelCriticalTaskAggregateV1Response,
    ReportControllerV1GetTopLevelCriticalTaskAggregateError,
    undefined,
    {},
    ReportControllerV1GetTopLevelCriticalTaskAggregateQueryParams,
    {}
  >({
    url: '/v1/report/top-level-critical-tasks',
    method: 'get',
    ...variables,
    signal,
  });

export function reportControllerV1GetTopLevelCriticalTaskAggregateQuery(
  variables: ReportControllerV1GetTopLevelCriticalTaskAggregateVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetTopLevelCriticalTaskAggregateV1Response>;
};

export function reportControllerV1GetTopLevelCriticalTaskAggregateQuery(
  variables:
    | ReportControllerV1GetTopLevelCriticalTaskAggregateVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetTopLevelCriticalTaskAggregateV1Response>)
    | reactQuery.SkipToken;
};

export function reportControllerV1GetTopLevelCriticalTaskAggregateQuery(
  variables:
    | ReportControllerV1GetTopLevelCriticalTaskAggregateVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/report/top-level-critical-tasks',
      operationId: 'reportControllerV1GetTopLevelCriticalTaskAggregate',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchReportControllerV1GetTopLevelCriticalTaskAggregate(
              variables,
              signal,
            ),
  };
}

export const useSuspenseReportControllerV1GetTopLevelCriticalTaskAggregate = <
  TData = Schemas.GetTopLevelCriticalTaskAggregateV1Response,
>(
  variables: ReportControllerV1GetTopLevelCriticalTaskAggregateVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetTopLevelCriticalTaskAggregateV1Response,
      ReportControllerV1GetTopLevelCriticalTaskAggregateError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetTopLevelCriticalTaskAggregateV1Response,
    ReportControllerV1GetTopLevelCriticalTaskAggregateError,
    TData
  >({
    ...reportControllerV1GetTopLevelCriticalTaskAggregateQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useReportControllerV1GetTopLevelCriticalTaskAggregate = <
  TData = Schemas.GetTopLevelCriticalTaskAggregateV1Response,
>(
  variables:
    | ReportControllerV1GetTopLevelCriticalTaskAggregateVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetTopLevelCriticalTaskAggregateV1Response,
      ReportControllerV1GetTopLevelCriticalTaskAggregateError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetTopLevelCriticalTaskAggregateV1Response,
    ReportControllerV1GetTopLevelCriticalTaskAggregateError,
    TData
  >({
    ...reportControllerV1GetTopLevelCriticalTaskAggregateQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ReportControllerV1GetTasksAggregatedByLevelQueryParams = {
  constructionSiteId: string;
  startDate: string;
  endDate: string;
};

export type ReportControllerV1GetTasksAggregatedByLevelError =
  Fetcher.ErrorWrapper<undefined>;

export type ReportControllerV1GetTasksAggregatedByLevelVariables = {
  queryParams: ReportControllerV1GetTasksAggregatedByLevelQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchReportControllerV1GetTasksAggregatedByLevel = (
  variables: ReportControllerV1GetTasksAggregatedByLevelVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetTasksAggregatedByLevelV1Response,
    ReportControllerV1GetTasksAggregatedByLevelError,
    undefined,
    {},
    ReportControllerV1GetTasksAggregatedByLevelQueryParams,
    {}
  >({
    url: '/v1/report/aggregated-tasks',
    method: 'get',
    ...variables,
    signal,
  });

export function reportControllerV1GetTasksAggregatedByLevelQuery(
  variables: ReportControllerV1GetTasksAggregatedByLevelVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetTasksAggregatedByLevelV1Response>;
};

export function reportControllerV1GetTasksAggregatedByLevelQuery(
  variables:
    | ReportControllerV1GetTasksAggregatedByLevelVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetTasksAggregatedByLevelV1Response>)
    | reactQuery.SkipToken;
};

export function reportControllerV1GetTasksAggregatedByLevelQuery(
  variables:
    | ReportControllerV1GetTasksAggregatedByLevelVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/report/aggregated-tasks',
      operationId: 'reportControllerV1GetTasksAggregatedByLevel',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchReportControllerV1GetTasksAggregatedByLevel(variables, signal),
  };
}

export const useSuspenseReportControllerV1GetTasksAggregatedByLevel = <
  TData = Schemas.GetTasksAggregatedByLevelV1Response,
>(
  variables: ReportControllerV1GetTasksAggregatedByLevelVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetTasksAggregatedByLevelV1Response,
      ReportControllerV1GetTasksAggregatedByLevelError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetTasksAggregatedByLevelV1Response,
    ReportControllerV1GetTasksAggregatedByLevelError,
    TData
  >({
    ...reportControllerV1GetTasksAggregatedByLevelQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useReportControllerV1GetTasksAggregatedByLevel = <
  TData = Schemas.GetTasksAggregatedByLevelV1Response,
>(
  variables:
    | ReportControllerV1GetTasksAggregatedByLevelVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetTasksAggregatedByLevelV1Response,
      ReportControllerV1GetTasksAggregatedByLevelError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetTasksAggregatedByLevelV1Response,
    ReportControllerV1GetTasksAggregatedByLevelError,
    TData
  >({
    ...reportControllerV1GetTasksAggregatedByLevelQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ProductionAnalyzeV1ControllerReportProductionAnalyzeQueryParams = {
  constructionSiteId: string;
  startDate?: string;
  endDate?: string;
  startRing?: number;
  endRing?: number;
  groupByType: 'shift' | 'team';
  seriesIds: string[];
  selectedSeriesIds: string[];
};

export type ProductionAnalyzeV1ControllerReportProductionAnalyzeError =
  Fetcher.ErrorWrapper<undefined>;

export type ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables = {
  queryParams: ProductionAnalyzeV1ControllerReportProductionAnalyzeQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchProductionAnalyzeV1ControllerReportProductionAnalyze = (
  variables: ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetReportProductionAnalyzeV1ResponseDto,
    ProductionAnalyzeV1ControllerReportProductionAnalyzeError,
    undefined,
    {},
    ProductionAnalyzeV1ControllerReportProductionAnalyzeQueryParams,
    {}
  >({
    url: '/v1/report-analyze/production-analyze',
    method: 'get',
    ...variables,
    signal,
  });

export function productionAnalyzeV1ControllerReportProductionAnalyzeQuery(
  variables: ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.GetReportProductionAnalyzeV1ResponseDto>;
};

export function productionAnalyzeV1ControllerReportProductionAnalyzeQuery(
  variables:
    | ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.GetReportProductionAnalyzeV1ResponseDto>)
    | reactQuery.SkipToken;
};

export function productionAnalyzeV1ControllerReportProductionAnalyzeQuery(
  variables:
    | ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/report-analyze/production-analyze',
      operationId: 'productionAnalyzeV1ControllerReportProductionAnalyze',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchProductionAnalyzeV1ControllerReportProductionAnalyze(
              variables,
              signal,
            ),
  };
}

export const useSuspenseProductionAnalyzeV1ControllerReportProductionAnalyze = <
  TData = Schemas.GetReportProductionAnalyzeV1ResponseDto,
>(
  variables: ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetReportProductionAnalyzeV1ResponseDto,
      ProductionAnalyzeV1ControllerReportProductionAnalyzeError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.GetReportProductionAnalyzeV1ResponseDto,
    ProductionAnalyzeV1ControllerReportProductionAnalyzeError,
    TData
  >({
    ...productionAnalyzeV1ControllerReportProductionAnalyzeQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useProductionAnalyzeV1ControllerReportProductionAnalyze = <
  TData = Schemas.GetReportProductionAnalyzeV1ResponseDto,
>(
  variables:
    | ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetReportProductionAnalyzeV1ResponseDto,
      ProductionAnalyzeV1ControllerReportProductionAnalyzeError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetReportProductionAnalyzeV1ResponseDto,
    ProductionAnalyzeV1ControllerReportProductionAnalyzeError,
    TData
  >({
    ...productionAnalyzeV1ControllerReportProductionAnalyzeQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ProductionAnalyzeV1ControllerReportProductionAnalyzeExportError =
  Fetcher.ErrorWrapper<undefined>;

export type ProductionAnalyzeV1ControllerReportProductionAnalyzeExportVariables =
  {
    body: Schemas.GetReportProductionAnalyzeExportV1InputDto;
  } & ApiContext['fetcherOptions'];

export const fetchProductionAnalyzeV1ControllerReportProductionAnalyzeExport = (
  variables: ProductionAnalyzeV1ControllerReportProductionAnalyzeExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    ProductionAnalyzeV1ControllerReportProductionAnalyzeExportError,
    Schemas.GetReportProductionAnalyzeExportV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/report-analyze/production-analyze/export',
    method: 'post',
    ...variables,
    signal,
  });

export const useProductionAnalyzeV1ControllerReportProductionAnalyzeExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      ProductionAnalyzeV1ControllerReportProductionAnalyzeExportError,
      ProductionAnalyzeV1ControllerReportProductionAnalyzeExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    ProductionAnalyzeV1ControllerReportProductionAnalyzeExportError,
    ProductionAnalyzeV1ControllerReportProductionAnalyzeExportVariables
  >({
    mutationFn: (
      variables: ProductionAnalyzeV1ControllerReportProductionAnalyzeExportVariables,
    ) =>
      fetchProductionAnalyzeV1ControllerReportProductionAnalyzeExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ActivityAnalyzeV1ControllerReportActivityAnalyzeError =
  Fetcher.ErrorWrapper<undefined>;

export type ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables = {
  body: Schemas.GetReportActivityAnalyzeV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchActivityAnalyzeV1ControllerReportActivityAnalyze = (
  variables: ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetReportActivityAnalyzeV1ResponseDto,
    ActivityAnalyzeV1ControllerReportActivityAnalyzeError,
    Schemas.GetReportActivityAnalyzeV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/report-analyze/activity-analyze',
    method: 'post',
    ...variables,
    signal,
  });

export const useActivityAnalyzeV1ControllerReportActivityAnalyze = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GetReportActivityAnalyzeV1ResponseDto,
      ActivityAnalyzeV1ControllerReportActivityAnalyzeError,
      ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GetReportActivityAnalyzeV1ResponseDto,
    ActivityAnalyzeV1ControllerReportActivityAnalyzeError,
    ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables
  >({
    mutationFn: (
      variables: ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables,
    ) =>
      fetchActivityAnalyzeV1ControllerReportActivityAnalyze(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type ActivityAnalyzeV1ControllerReportActivityAnalyzeExportError =
  Fetcher.ErrorWrapper<undefined>;

export type ActivityAnalyzeV1ControllerReportActivityAnalyzeExportVariables = {
  body: Schemas.GetReportActivityAnalyzeExportV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchActivityAnalyzeV1ControllerReportActivityAnalyzeExport = (
  variables: ActivityAnalyzeV1ControllerReportActivityAnalyzeExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    ActivityAnalyzeV1ControllerReportActivityAnalyzeExportError,
    Schemas.GetReportActivityAnalyzeExportV1InputDto,
    {},
    {},
    {}
  >({
    url: '/v1/report-analyze/activity-analyze/export',
    method: 'post',
    ...variables,
    signal,
  });

export const useActivityAnalyzeV1ControllerReportActivityAnalyzeExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      ActivityAnalyzeV1ControllerReportActivityAnalyzeExportError,
      ActivityAnalyzeV1ControllerReportActivityAnalyzeExportVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    ActivityAnalyzeV1ControllerReportActivityAnalyzeExportError,
    ActivityAnalyzeV1ControllerReportActivityAnalyzeExportVariables
  >({
    mutationFn: (
      variables: ActivityAnalyzeV1ControllerReportActivityAnalyzeExportVariables,
    ) =>
      fetchActivityAnalyzeV1ControllerReportActivityAnalyzeExport(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SteeringTableControllerExportTableError =
  Fetcher.ErrorWrapper<undefined>;

export type SteeringTableControllerExportTableVariables = {
  body: Schemas.GenerateSteeringDataExportInputDto;
} & ApiContext['fetcherOptions'];

export const fetchSteeringTableControllerExportTable = (
  variables: SteeringTableControllerExportTableVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GenerateExportResponseDto,
    SteeringTableControllerExportTableError,
    Schemas.GenerateSteeringDataExportInputDto,
    {},
    {},
    {}
  >({ url: '/steering/table/export', method: 'post', ...variables, signal });

export const useSteeringTableControllerExportTable = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GenerateExportResponseDto,
      SteeringTableControllerExportTableError,
      SteeringTableControllerExportTableVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.GenerateExportResponseDto,
    SteeringTableControllerExportTableError,
    SteeringTableControllerExportTableVariables
  >({
    mutationFn: (variables: SteeringTableControllerExportTableVariables) =>
      fetchSteeringTableControllerExportTable(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type TunnelFactoryV1ControllerGetAggregatedQueryParams = {
  /**
   * Target construction site id (M2M scope).
   */
  constructionSiteId: string;
  /**
   * Ids of the parameters to aggregate (≥1).
   */
  parameterIds: string[];
  /**
   * Start of the period (ISO 8601). Must be provided together with endDate, or omitted together with endDate (real-time mode).
   */
  startDate?: string;
  /**
   * End of the period (ISO 8601). Must be provided together with startDate, or omitted together with startDate (real-time mode).
   */
  endDate?: string;
  /**
   * Bucket granularity in minutes (1 to 5). Drives the real-time window (`now-N min → now`) and the historical `time_bucket`. Omitted → 5 (backward compatible).
   *
   * @default 5
   */
  aggregationMinutes?: number;
};

export type TunnelFactoryV1ControllerGetAggregatedError =
  Fetcher.ErrorWrapper<undefined>;

export type TunnelFactoryV1ControllerGetAggregatedVariables = {
  queryParams: TunnelFactoryV1ControllerGetAggregatedQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchTunnelFactoryV1ControllerGetAggregated = (
  variables: TunnelFactoryV1ControllerGetAggregatedVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AggregatedV1OutputDto,
    TunnelFactoryV1ControllerGetAggregatedError,
    undefined,
    {},
    TunnelFactoryV1ControllerGetAggregatedQueryParams,
    {}
  >({
    url: '/v1/tunnel-factory/aggregated',
    method: 'get',
    ...variables,
    signal,
  });

export function tunnelFactoryV1ControllerGetAggregatedQuery(
  variables: TunnelFactoryV1ControllerGetAggregatedVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.AggregatedV1OutputDto>;
};

export function tunnelFactoryV1ControllerGetAggregatedQuery(
  variables:
    | TunnelFactoryV1ControllerGetAggregatedVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.AggregatedV1OutputDto>)
    | reactQuery.SkipToken;
};

export function tunnelFactoryV1ControllerGetAggregatedQuery(
  variables:
    | TunnelFactoryV1ControllerGetAggregatedVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/v1/tunnel-factory/aggregated',
      operationId: 'tunnelFactoryV1ControllerGetAggregated',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchTunnelFactoryV1ControllerGetAggregated(variables, signal),
  };
}

export const useSuspenseTunnelFactoryV1ControllerGetAggregated = <
  TData = Schemas.AggregatedV1OutputDto,
>(
  variables: TunnelFactoryV1ControllerGetAggregatedVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AggregatedV1OutputDto,
      TunnelFactoryV1ControllerGetAggregatedError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.AggregatedV1OutputDto,
    TunnelFactoryV1ControllerGetAggregatedError,
    TData
  >({
    ...tunnelFactoryV1ControllerGetAggregatedQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useTunnelFactoryV1ControllerGetAggregated = <
  TData = Schemas.AggregatedV1OutputDto,
>(
  variables:
    | TunnelFactoryV1ControllerGetAggregatedVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AggregatedV1OutputDto,
      TunnelFactoryV1ControllerGetAggregatedError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.AggregatedV1OutputDto,
    TunnelFactoryV1ControllerGetAggregatedError,
    TData
  >({
    ...tunnelFactoryV1ControllerGetAggregatedQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: '/v1/dashboard/progress-history';
      operationId: 'dashboardProgressHistoryV1ControllerProgressHistory';
      variables:
        | DashboardProgressHistoryV1ControllerProgressHistoryVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/dashboard/daily-advancement';
      operationId: 'dashboardDailyAdvancementV1ControllerRingPerShift';
      variables:
        | DashboardDailyAdvancementV1ControllerRingPerShiftVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/dashboard/daily-advancement/daily-length';
      operationId: 'dashboardDailyAdvancementV1ControllerDailyLengthAdvancement';
      variables:
        | DashboardDailyAdvancementV1ControllerDailyLengthAdvancementVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/dashboard/performance-metrics';
      operationId: 'performanceMetricsControllerGetPerformanceMetrics';
      variables:
        | PerformanceMetricsControllerGetPerformanceMetricsVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/dashboard/tbm-infos';
      operationId: 'dashboardTbmInfosV1ControllerGetTbmInfos';
      variables:
        | DashboardTbmInfosV1ControllerGetTbmInfosVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/data-analysis/{constructionSiteId}/graph-set/{id}';
      operationId: 'dataAnalysisControllerGetSavedGraphSet';
      variables:
        | DataAnalysisControllerGetSavedGraphSetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/indicator/analyze';
      operationId: 'indicatorV1ControllerGetIndicatorAnalyzeData';
      variables:
        | IndicatorV1ControllerGetIndicatorAnalyzeDataVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/production-and-performance/progress-history';
      operationId: 'progressHistoryControllerProgressHistory';
      variables:
        | ProgressHistoryControllerProgressHistoryVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/production-and-performance/ring-per-day';
      operationId: 'ringPerDayControllerRingPerDay';
      variables: RingPerDayControllerRingPerDayVariables | reactQuery.SkipToken;
    }
  | {
      path: '/production-and-performance/excavation-and-building-duration';
      operationId: 'excavationAndBuildingDurationControllerGetExcavationAndBuildingDuration';
      variables:
        | ExcavationAndBuildingDurationControllerGetExcavationAndBuildingDurationVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/production-and-performance/planning';
      operationId: 'planningControllerGetPlanning';
      variables: PlanningControllerGetPlanningVariables | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/board-config';
      operationId: 'boardConfigV1ControllerGet';
      variables: BoardConfigV1ControllerGetVariables | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/board-viewer-config';
      operationId: 'boardViewerConfigV1ControllerGet';
      variables:
        | BoardViewerConfigV1ControllerGetVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/record-segment-defect/range-stats';
      operationId: 'recordSegmentDefectV1ControllerGetRangeStats';
      variables:
        | RecordSegmentDefectV1ControllerGetRangeStatsVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/segments/history';
      operationId: 'segmentHistoryV1ControllerGetSegmentsHistory';
      variables:
        | SegmentHistoryV1ControllerGetSegmentsHistoryVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/scan-config';
      operationId: 'scanConfigV1ControllerGetByConstructionSite';
      variables:
        | ScanConfigV1ControllerGetByConstructionSiteVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/quarantine-defect-picture';
      operationId: 'quarantineDefectPictureV1ControllerGetByDefect';
      variables:
        | QuarantineDefectPictureV1ControllerGetByDefectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/defect-repair-picture';
      operationId: 'defectRepairPictureV1ControllerGetByRepair';
      variables:
        | DefectRepairPictureV1ControllerGetByRepairVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/defect-report-picture';
      operationId: 'defectReportPictureV1ControllerGetByDefect';
      variables:
        | DefectReportPictureV1ControllerGetByDefectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/defect-report-pictures/by-rings';
      operationId: 'defectReportPictureV1ControllerGetListByRings';
      variables:
        | DefectReportPictureV1ControllerGetListByRingsVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/defect-report-types';
      operationId: 'defectReportTypeV1ControllerGetList';
      variables:
        | DefectReportTypeV1ControllerGetListVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/defect-reports';
      operationId: 'defectReportV1ControllerGetList';
      variables:
        | DefectReportV1ControllerGetListVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/defect-reports/by-rings';
      operationId: 'defectReportV1ControllerGetListByRings';
      variables:
        | DefectReportV1ControllerGetListByRingsVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/indicators';
      operationId: 'indicatorV1ControllerGetList';
      variables: IndicatorV1ControllerGetListVariables | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/repair-reports/by-rings';
      operationId: 'repairReportV1ControllerGetListByRings';
      variables:
        | RepairReportV1ControllerGetListByRingsVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/repair-report-picture';
      operationId: 'repairReportPictureV1ControllerGetByRepair';
      variables:
        | RepairReportPictureV1ControllerGetByRepairVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/repair-report-pictures/by-rings';
      operationId: 'repairReportPictureV1ControllerGetListByRings';
      variables:
        | RepairReportPictureV1ControllerGetListByRingsVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/rings';
      operationId: 'ringV1ControllerGetRings';
      variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/rings-segments';
      operationId: 'ringV1ControllerGetRingsDetails';
      variables:
        | RingV1ControllerGetRingsDetailsVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/rings-validation';
      operationId: 'ringValidationV1ControllerGetList';
      variables:
        | RingValidationV1ControllerGetListVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/rings-validation/{ringId}';
      operationId: 'ringValidationV1ControllerGetDetail';
      variables:
        | RingValidationV1ControllerGetDetailVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/rings-validation/{ringId}/pictures';
      operationId: 'ringValidationV1ControllerGetPictures';
      variables:
        | RingValidationV1ControllerGetPicturesVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/segment-refusal-picture';
      operationId: 'segmentRefusalPictureV1ControllerGetByRefusal';
      variables:
        | SegmentRefusalPictureV1ControllerGetByRefusalVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/segments';
      operationId: 'segmentV1ControllerGetSegmentsByConstructionSite';
      variables:
        | SegmentV1ControllerGetSegmentsByConstructionSiteVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/quality/{constructionSiteId}/tunnel-position';
      operationId: 'tunnelPositionV1ControllerGet';
      variables: TunnelPositionV1ControllerGetVariables | reactQuery.SkipToken;
    }
  | {
      path: '/v1/report/top-level-critical-tasks';
      operationId: 'reportControllerV1GetTopLevelCriticalTaskAggregate';
      variables:
        | ReportControllerV1GetTopLevelCriticalTaskAggregateVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/report/aggregated-tasks';
      operationId: 'reportControllerV1GetTasksAggregatedByLevel';
      variables:
        | ReportControllerV1GetTasksAggregatedByLevelVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/report-analyze/production-analyze';
      operationId: 'productionAnalyzeV1ControllerReportProductionAnalyze';
      variables:
        | ProductionAnalyzeV1ControllerReportProductionAnalyzeVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/v1/tunnel-factory/aggregated';
      operationId: 'tunnelFactoryV1ControllerGetAggregated';
      variables:
        | TunnelFactoryV1ControllerGetAggregatedVariables
        | reactQuery.SkipToken;
    };
